var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _g, _path83, _path84, _path85, _path86, _g2, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _g3, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _g4, _g5, _g6, _g7, _path257, _path258, _g8, _path259, _path260, _g9, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResoucesbanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 387,
    viewBox: "0 0 454 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M264.252 384.002L448.367 297.496C455.907 293.954 455.869 283.217 448.305 279.727L216.747 172.893C208.147 168.926 198.252 168.871 189.61 172.744L5.54138 255.226C-1.7724 258.503 -1.86817 268.852 5.38365 272.264L242.849 383.996C249.626 387.185 257.473 387.187 264.252 384.002Z",
    fill: "url(#paint0_linear_3956_9012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.252 369.773L448.367 283.268C455.907 279.725 455.869 268.988 448.305 265.499L216.747 158.665C208.148 154.697 198.252 154.643 189.61 158.515L5.54163 240.997C-1.77216 244.274 -1.86793 254.623 5.38389 258.035L242.849 369.767C249.626 372.956 257.473 372.958 264.252 369.773Z",
    fill: "#2D2F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.252 369.081L448.367 282.575C455.907 279.033 455.869 268.296 448.305 264.806L216.747 157.972C208.148 154.005 198.252 153.95 189.61 157.823L5.54163 240.305C-1.77216 243.582 -1.86793 253.931 5.38389 257.343L242.849 369.075C249.626 372.264 257.473 372.266 264.252 369.081Z",
    fill: "url(#paint1_linear_3956_9012)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.252 362.43L448.367 275.925C455.907 272.383 455.869 261.646 448.305 258.156L216.747 151.322C208.148 147.354 198.252 147.3 189.61 151.173L5.54163 233.654C-1.77216 236.932 -1.86793 247.28 5.38389 250.692L242.849 362.425C249.626 365.613 257.473 365.616 264.252 362.43Z",
    fill: "url(#paint2_linear_3956_9012)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.485 183.161L236.4 181.572V157.434L240.485 159.84V183.161Z",
    fill: "url(#paint3_linear_3956_9012)",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.701 181.404L240.656 183.105V159.937L242.701 161.092V181.404Z",
    fill: "#278780",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M307.222 215.313L303.137 213.723V189.585L307.222 191.991V215.313Z",
    fill: "url(#paint4_linear_3956_9012)",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M309.439 213.555L307.393 215.256V192.089L309.439 193.243V213.555Z",
    fill: "#278780",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.698 32.7057L332.461 84.6814C335.891 86.3835 338.004 89.8727 338.004 93.8448V192.845C338.004 198.02 332.393 201.716 327.931 199.502L224.584 148.228C221.555 146.726 219.689 143.645 219.689 140.138V38C219.689 33.8837 224.152 30.9463 227.698 32.7057Z",
    fill: "url(#paint5_linear_3956_9012)",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M224.034 34.5749L328.797 86.5505C332.227 88.2526 334.34 91.7419 334.34 95.7136V194.714C334.34 199.889 328.729 203.585 324.267 201.371L220.919 150.097C217.89 148.595 216.025 145.514 216.025 142.007V39.8691C216.025 35.7529 220.488 32.8155 224.034 34.5749Z",
    fill: "url(#paint6_linear_3956_9012)",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M327.629 198.936C326.998 198.989 326.387 198.872 325.814 198.588L222.466 147.314C220.386 146.282 219.093 144.146 219.093 141.74V39.6019C219.093 38.2012 220.27 37.2341 221.362 37.1415C221.75 37.1085 222.13 37.1819 222.488 37.3598L327.251 89.3354C329.731 90.5663 331.272 93.1131 331.272 95.9823V194.983C331.272 196.269 330.675 197.161 330.174 197.684C329.488 198.4 328.56 198.856 327.63 198.935L327.629 198.936Z",
    fill: "#FFFDFF",
    stroke: "#608EE5",
    strokeWidth: 0.512134,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M230.86 53.3593L230.86 53.3593C230.502 53.1773 230.173 52.8633 229.934 52.5023C229.695 52.1407 229.55 51.7402 229.55 51.3889C229.55 51.04 229.691 50.8135 229.901 50.7106C230.114 50.6058 230.424 50.6169 230.782 50.7993L259.15 65.2434L259.189 65.1673L259.15 65.2434C259.508 65.4254 259.836 65.7394 260.075 66.1004C260.315 66.462 260.459 66.8625 260.459 67.2138C260.459 67.5628 260.318 67.7893 260.109 67.8922C259.895 67.9971 259.586 67.986 259.227 67.8035L230.86 53.3593Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.463 80.7143L268.463 80.7142L230.86 61.6103C230.502 61.4283 230.173 61.1143 229.934 60.7533C229.695 60.3917 229.55 59.9912 229.55 59.6399C229.55 59.291 229.691 59.0645 229.901 58.9616C230.114 58.8568 230.424 58.8679 230.782 59.0503L230.782 59.0504L268.386 78.1543C268.743 78.3363 269.072 78.6503 269.311 79.0113C269.55 79.3729 269.695 79.7734 269.695 80.1247C269.695 80.4736 269.554 80.7001 269.344 80.803C269.131 80.9079 268.821 80.8967 268.463 80.7143Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.731 92.7997L249.732 92.7994L249.725 92.7963C249.397 92.6378 249.193 92.3067 249.193 91.9255V91.9157L249.191 91.9062L247.928 86.4848C247.93 86.4585 247.943 86.4201 247.975 86.3696C248.009 86.315 248.061 86.2536 248.128 86.1886C248.262 86.0587 248.45 85.9218 248.659 85.8051C248.868 85.6883 249.094 85.5939 249.306 85.5464C249.518 85.4986 249.705 85.5007 249.843 85.5628C249.843 85.5629 249.844 85.5631 249.844 85.5632L264.745 92.7696L264.782 92.6927L264.745 92.7696C265.051 92.9174 265.241 93.2264 265.241 93.5821V99.3537C265.192 99.5558 265.063 99.7522 264.881 99.9322C264.698 100.114 264.465 100.275 264.225 100.403C263.985 100.531 263.739 100.624 263.53 100.673C263.426 100.698 263.332 100.711 263.254 100.712C263.177 100.714 263.122 100.703 263.087 100.687L249.731 92.7997Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M248.495 86.3401L248.495 86.3401L263.398 93.5474L263.398 93.5474C263.704 93.6952 263.894 94.0042 263.894 94.36V100.142V100.142C263.894 100.563 263.438 100.857 263.084 100.686C263.084 100.686 263.084 100.686 263.084 100.686L248.378 93.5742C248.051 93.4156 247.847 93.0845 247.847 92.7034V86.7773C247.847 86.4385 248.213 86.2037 248.495 86.3401Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M252.784 91.1549L252.784 91.1549C252.689 91.1094 252.6 91.027 252.534 90.9292C252.467 90.8309 252.43 90.725 252.43 90.636C252.43 90.5496 252.464 90.5047 252.502 90.4848C252.544 90.4633 252.615 90.4588 252.71 90.5047L258.958 93.5157C259.053 93.5612 259.143 93.6436 259.209 93.7414C259.275 93.8397 259.312 93.9456 259.312 94.0346C259.312 94.121 259.278 94.1659 259.24 94.1858C259.199 94.2073 259.128 94.2118 259.033 94.1659L252.784 91.1549Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M262.269 97.7434L249.547 91.6129C249.452 91.5674 249.362 91.485 249.296 91.3872C249.23 91.2889 249.193 91.183 249.193 91.0941C249.193 91.0077 249.227 90.9627 249.265 90.9429C249.306 90.9213 249.377 90.9168 249.472 90.9627L262.195 97.0931C262.29 97.1386 262.379 97.221 262.445 97.3188C262.512 97.4171 262.549 97.523 262.549 97.612C262.549 97.6984 262.515 97.7433 262.477 97.7632C262.435 97.7847 262.364 97.7892 262.269 97.7434Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.975 82.5077L224.976 82.5074L224.969 82.5043C224.641 82.3458 224.437 82.0147 224.437 81.6335V81.6237L224.435 81.6142L223.172 76.1928C223.174 76.1665 223.187 76.1281 223.219 76.0776C223.253 76.023 223.305 75.9616 223.372 75.8966C223.506 75.7667 223.694 75.6298 223.903 75.5131C224.112 75.3963 224.338 75.3019 224.55 75.2544C224.762 75.2066 224.949 75.2087 225.087 75.2708C225.087 75.2709 225.088 75.2711 225.088 75.2712L239.989 82.4776L240.026 82.4007L239.989 82.4776C240.295 82.6254 240.485 82.9344 240.485 83.2901V89.0619C240.436 89.264 240.307 89.4604 240.125 89.6404C239.942 89.8225 239.709 89.9833 239.469 90.1112C239.229 90.2391 238.983 90.3324 238.774 90.3814C238.67 90.4059 238.576 90.4189 238.498 90.4203C238.421 90.4216 238.366 90.4114 238.331 90.3953L224.975 82.5077Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M238.329 90.3932L238.329 90.3932L223.623 83.2812C223.295 83.1226 223.091 82.7916 223.091 82.4104V76.4843C223.091 76.1456 223.457 75.9107 223.739 76.0472L223.739 76.0472L238.642 83.2544L238.642 83.2544C238.948 83.4022 239.138 83.7112 239.138 84.067V89.8486C239.138 89.8486 239.138 89.8486 239.138 89.8486C239.138 90.2701 238.683 90.5645 238.329 90.3932Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M228.028 80.8639L228.028 80.8639C227.933 80.8184 227.844 80.736 227.778 80.6382C227.711 80.5399 227.674 80.434 227.674 80.345C227.674 80.2586 227.708 80.2137 227.746 80.1938C227.788 80.1723 227.859 80.1678 227.954 80.2136L234.203 83.2247C234.297 83.2702 234.387 83.3526 234.453 83.4504C234.519 83.5487 234.556 83.6546 234.556 83.7435C234.556 83.8299 234.522 83.8749 234.484 83.8947C234.443 83.9163 234.372 83.9208 234.277 83.8749L228.028 80.8639Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M237.513 87.4514L224.791 81.3209C224.696 81.2754 224.606 81.193 224.54 81.0952C224.474 80.9969 224.437 80.891 224.437 80.8021C224.437 80.7157 224.471 80.6707 224.509 80.6509C224.55 80.6293 224.621 80.6249 224.717 80.6707L237.439 86.8011C237.534 86.8467 237.623 86.929 237.689 87.0268C237.756 87.1251 237.793 87.2311 237.793 87.32C237.793 87.4064 237.759 87.4513 237.721 87.4712C237.679 87.4927 237.608 87.4972 237.513 87.4514Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M303.675 93.4647L303.675 93.4645L303.668 93.4614C303.341 93.3028 303.137 92.9718 303.137 92.5906V92.5808L303.134 92.5712L301.871 87.1498C301.873 87.1235 301.886 87.0851 301.918 87.0347C301.953 86.9801 302.005 86.9186 302.072 86.8536C302.206 86.7237 302.393 86.5868 302.602 86.4701C302.811 86.3534 303.038 86.259 303.249 86.2115C303.462 86.1637 303.648 86.1657 303.786 86.2278C303.787 86.228 303.787 86.2281 303.787 86.2282L318.688 93.4346L318.725 93.3578L318.688 93.4346C318.994 93.5824 319.184 93.8914 319.184 94.2472V100.019C319.136 100.221 319.006 100.417 318.824 100.597C318.641 100.779 318.409 100.94 318.168 101.068C317.928 101.196 317.682 101.289 317.473 101.338C317.369 101.363 317.275 101.376 317.198 101.377C317.121 101.379 317.065 101.368 317.03 101.352L303.675 93.4647Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.439 87.0052L302.439 87.0052L317.341 94.2124L317.342 94.2124C317.647 94.3602 317.838 94.6693 317.838 95.025V100.806C317.837 101.228 317.381 101.522 317.028 101.351L302.322 94.2392C301.994 94.0806 301.79 93.7496 301.79 93.3684V87.4423C301.79 87.1036 302.156 86.8687 302.439 87.0052Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.725 91.82L306.725 91.82C306.631 91.7744 306.541 91.6921 306.475 91.5942C306.409 91.4959 306.371 91.39 306.371 91.3011C306.371 91.2147 306.405 91.1697 306.444 91.1499C306.485 91.1284 306.556 91.1239 306.651 91.1697L312.9 94.1807C312.994 94.2263 313.084 94.3086 313.15 94.4064C313.216 94.5048 313.254 94.6107 313.254 94.6996C313.254 94.786 313.22 94.831 313.182 94.8508C313.14 94.8723 313.069 94.8768 312.974 94.831L306.725 91.82Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M316.212 98.4082L303.489 92.2778C303.394 92.2323 303.305 92.1499 303.239 92.0521C303.172 91.9538 303.135 91.8479 303.135 91.7591C303.135 91.6727 303.169 91.6277 303.207 91.6079C303.249 91.5864 303.32 91.5819 303.415 91.6277L316.137 97.7581C316.232 97.8037 316.322 97.886 316.388 97.9838C316.454 98.0821 316.491 98.188 316.491 98.2769C316.491 98.3632 316.457 98.4082 316.419 98.428C316.378 98.4496 316.307 98.454 316.212 98.4082Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M303.675 176.743L303.675 176.743L303.668 176.74C303.341 176.581 303.137 176.25 303.137 175.869V175.859L303.134 175.85L301.871 170.428C301.873 170.402 301.886 170.363 301.918 170.313C301.953 170.258 302.005 170.197 302.072 170.132C302.206 170.002 302.393 169.865 302.602 169.748C302.811 169.632 303.038 169.537 303.249 169.49C303.462 169.442 303.648 169.444 303.786 169.506C303.787 169.506 303.787 169.506 303.787 169.507L318.688 176.713L318.725 176.636L318.688 176.713C318.994 176.861 319.184 177.17 319.184 177.525V183.297C319.136 183.499 319.006 183.696 318.824 183.876C318.641 184.058 318.409 184.219 318.168 184.347C317.928 184.474 317.682 184.568 317.473 184.617C317.369 184.641 317.275 184.654 317.198 184.656C317.121 184.657 317.065 184.647 317.03 184.631L303.675 176.743Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M317.028 184.63L317.028 184.63L302.322 177.518C301.994 177.359 301.79 177.028 301.79 176.647V170.721C301.79 170.382 302.156 170.147 302.439 170.283L302.439 170.283L317.341 177.491L317.342 177.491C317.647 177.639 317.838 177.948 317.838 178.303V184.085C317.837 184.506 317.381 184.801 317.028 184.63Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.725 175.099L306.725 175.099C306.631 175.054 306.541 174.971 306.475 174.874C306.409 174.775 306.371 174.669 306.371 174.58C306.371 174.494 306.405 174.449 306.444 174.429C306.485 174.408 306.556 174.403 306.651 174.449L312.9 177.46C312.994 177.506 313.084 177.588 313.15 177.686C313.216 177.784 313.254 177.89 313.254 177.979C313.254 178.065 313.22 178.11 313.182 178.13C313.14 178.152 313.069 178.156 312.974 178.11L306.725 175.099Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M316.212 181.688L303.489 175.557C303.394 175.512 303.305 175.429 303.239 175.332C303.172 175.233 303.135 175.127 303.135 175.038C303.135 174.952 303.169 174.907 303.207 174.887C303.249 174.866 303.32 174.861 303.415 174.907L316.137 181.037C316.232 181.083 316.322 181.165 316.388 181.263C316.454 181.361 316.491 181.467 316.491 181.556C316.491 181.643 316.457 181.688 316.419 181.708C316.378 181.729 316.307 181.734 316.212 181.688Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M227.829 141.915L227.829 141.915L227.823 141.912C227.495 141.753 227.291 141.422 227.291 141.041V141.031L227.289 141.021L226.025 135.6C226.027 135.574 226.041 135.535 226.073 135.485C226.107 135.43 226.159 135.369 226.226 135.304C226.36 135.174 226.547 135.037 226.756 134.92C226.965 134.804 227.192 134.709 227.403 134.662C227.616 134.614 227.803 134.616 227.941 134.678C227.941 134.678 227.941 134.678 227.941 134.678L242.843 141.885L242.88 141.808L242.843 141.885C243.148 142.033 243.339 142.342 243.339 142.697V148.469C243.29 148.671 243.16 148.868 242.979 149.048C242.795 149.23 242.563 149.39 242.322 149.518C242.082 149.646 241.836 149.74 241.627 149.789C241.523 149.813 241.43 149.826 241.352 149.827C241.275 149.829 241.22 149.819 241.185 149.803L227.829 141.915Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M226.592 135.455L226.592 135.455L241.495 142.663L241.495 142.663C241.801 142.81 241.991 143.119 241.991 143.475V149.257C241.991 149.257 241.991 149.257 241.991 149.257C241.991 149.678 241.535 149.973 241.182 149.801L226.476 142.689C226.148 142.531 225.944 142.2 225.944 141.819V135.893C225.944 135.554 226.31 135.319 226.592 135.455Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M230.88 140.27L230.88 140.27C230.785 140.225 230.696 140.142 230.63 140.044C230.563 139.946 230.526 139.84 230.526 139.751C230.526 139.665 230.56 139.62 230.598 139.6C230.64 139.579 230.711 139.574 230.806 139.62L237.055 142.631C237.149 142.676 237.239 142.759 237.305 142.857C237.371 142.955 237.408 143.061 237.408 143.15C237.408 143.236 237.375 143.281 237.336 143.301C237.295 143.323 237.224 143.327 237.129 143.281L230.88 140.27Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M240.366 146.858L240.366 146.858L227.644 140.728C227.549 140.682 227.459 140.6 227.393 140.502C227.327 140.404 227.29 140.298 227.29 140.209C227.29 140.123 227.324 140.078 227.362 140.058C227.404 140.037 227.474 140.032 227.57 140.078L240.292 146.208C240.387 146.254 240.476 146.336 240.542 146.434C240.609 146.532 240.646 146.638 240.646 146.727C240.646 146.813 240.612 146.858 240.574 146.878C240.532 146.9 240.461 146.904 240.366 146.858Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M230.905 113.775L230.905 113.775L230.898 113.772C230.571 113.613 230.367 113.282 230.367 112.901V112.891L230.364 112.882L229.101 107.46C229.103 107.434 229.116 107.396 229.148 107.345C229.183 107.291 229.235 107.229 229.302 107.164C229.436 107.034 229.623 106.897 229.832 106.781C230.041 106.664 230.267 106.57 230.479 106.522C230.692 106.474 230.878 106.476 231.016 106.538C231.017 106.539 231.017 106.539 231.017 106.539L245.918 113.745L245.955 113.668L245.918 113.745C246.224 113.893 246.414 114.202 246.414 114.558V120.329C246.366 120.531 246.236 120.728 246.054 120.908C245.871 121.09 245.639 121.251 245.398 121.379C245.158 121.507 244.912 121.6 244.703 121.649C244.599 121.673 244.505 121.686 244.428 121.688C244.351 121.689 244.295 121.679 244.26 121.663L230.905 113.775Z",
    fill: "#9ABB50",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M229.668 107.316L229.668 107.316L244.571 114.523L244.571 114.523C244.877 114.671 245.067 114.98 245.067 115.336V121.117C245.067 121.117 245.067 121.117 245.067 121.117C245.067 121.539 244.611 121.833 244.258 121.662L229.552 114.55C229.224 114.391 229.02 114.06 229.02 113.679V107.753C229.02 107.414 229.386 107.179 229.668 107.316Z",
    fill: "#608EE5",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.956 112.131L233.956 112.131C233.862 112.085 233.772 112.003 233.706 111.905C233.64 111.806 233.602 111.701 233.602 111.612C233.602 111.525 233.636 111.48 233.674 111.46C233.716 111.439 233.787 111.434 233.882 111.48L240.131 114.491C240.225 114.537 240.315 114.619 240.381 114.717C240.447 114.815 240.484 114.921 240.484 115.01C240.484 115.097 240.451 115.142 240.412 115.161C240.371 115.183 240.3 115.187 240.205 115.142L233.956 112.131Z",
    fill: "white",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M243.441 118.719L230.719 112.589C230.624 112.543 230.535 112.461 230.469 112.363C230.402 112.264 230.365 112.159 230.365 112.07C230.365 111.983 230.399 111.938 230.437 111.918C230.479 111.897 230.55 111.892 230.645 111.938L243.367 118.069C243.462 118.114 243.552 118.197 243.618 118.294C243.684 118.393 243.721 118.499 243.721 118.588C243.721 118.674 243.687 118.719 243.649 118.739C243.608 118.76 243.537 118.765 243.441 118.719Z",
    fill: "white",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M252.584 124.084L252.585 124.084L252.578 124.081C252.251 123.922 252.046 123.591 252.046 123.21V123.2L252.044 123.19L250.781 117.769C250.783 117.743 250.796 117.704 250.828 117.654C250.862 117.599 250.914 117.538 250.981 117.473C251.115 117.343 251.303 117.206 251.512 117.089C251.721 116.973 251.947 116.878 252.159 116.831C252.371 116.783 252.558 116.785 252.696 116.847C252.696 116.847 252.697 116.847 252.697 116.847L267.598 124.054L267.635 123.977L267.598 124.054C267.904 124.202 268.094 124.511 268.094 124.866V130.638C268.045 130.84 267.916 131.036 267.734 131.216C267.551 131.398 267.318 131.559 267.078 131.687C266.838 131.815 266.592 131.908 266.383 131.957C266.279 131.982 266.185 131.995 266.107 131.996C266.03 131.998 265.975 131.988 265.94 131.971L252.584 124.084Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M251.348 117.624L251.348 117.624L266.251 124.832L266.251 124.832C266.557 124.979 266.747 125.288 266.747 125.644V131.426C266.747 131.847 266.291 132.142 265.937 131.971C265.937 131.971 265.937 131.971 265.937 131.971L251.232 124.859C250.904 124.7 250.7 124.369 250.7 123.988V118.061C250.7 117.723 251.066 117.488 251.348 117.624Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M255.637 122.439L255.637 122.439C255.542 122.394 255.453 122.311 255.387 122.213C255.32 122.115 255.283 122.009 255.283 121.92C255.283 121.834 255.317 121.789 255.355 121.769C255.397 121.748 255.468 121.743 255.563 121.789L261.811 124.8C261.906 124.845 261.996 124.928 262.062 125.026C262.128 125.124 262.165 125.23 262.165 125.319C262.165 125.405 262.131 125.45 262.093 125.47C262.052 125.491 261.981 125.496 261.886 125.45L255.637 122.439Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.122 129.027L252.4 122.897C252.305 122.851 252.215 122.769 252.149 122.671C252.083 122.573 252.046 122.467 252.046 122.378C252.046 122.292 252.08 122.247 252.118 122.227C252.159 122.206 252.23 122.201 252.325 122.247L265.048 128.377C265.143 128.423 265.232 128.505 265.298 128.603C265.365 128.701 265.402 128.807 265.402 128.896C265.402 128.982 265.368 129.027 265.33 129.047C265.288 129.069 265.217 129.073 265.122 129.027Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M274.264 134.389L274.264 134.388L274.257 134.385C273.93 134.227 273.726 133.896 273.726 133.514V133.505L273.723 133.495L272.46 128.074C272.462 128.047 272.475 128.009 272.507 127.958C272.542 127.904 272.593 127.842 272.66 127.777C272.794 127.648 272.982 127.511 273.191 127.394C273.4 127.277 273.626 127.183 273.838 127.135C274.051 127.087 274.237 127.09 274.375 127.152C274.375 127.152 274.376 127.152 274.376 127.152L289.277 134.358L289.314 134.282L289.277 134.358C289.583 134.506 289.773 134.815 289.773 135.171V140.943C289.725 141.145 289.595 141.341 289.413 141.521C289.23 141.703 288.998 141.864 288.757 141.992C288.517 142.12 288.271 142.213 288.062 142.262C287.958 142.287 287.864 142.3 287.787 142.301C287.71 142.302 287.654 142.292 287.619 142.276L274.264 134.389Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M273.027 127.929L273.027 127.929L287.93 135.136L287.93 135.136C288.235 135.284 288.426 135.593 288.426 135.949V141.73C288.426 141.73 288.426 141.73 288.426 141.73C288.426 142.152 287.97 142.446 287.616 142.275L272.91 135.163C272.582 135.004 272.378 134.673 272.378 134.292V128.366C272.378 128.027 272.745 127.793 273.027 127.929Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.314 132.745L277.314 132.745C277.22 132.699 277.13 132.617 277.064 132.519C276.998 132.421 276.96 132.315 276.96 132.226C276.96 132.139 276.994 132.095 277.032 132.075C277.074 132.053 277.145 132.049 277.24 132.095L283.489 135.106C283.583 135.151 283.673 135.233 283.739 135.331C283.805 135.43 283.842 135.535 283.842 135.624C283.842 135.711 283.809 135.756 283.77 135.776C283.729 135.797 283.658 135.802 283.563 135.756L277.314 132.745Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M286.8 139.333L274.078 133.203C273.983 133.157 273.894 133.075 273.828 132.977C273.761 132.879 273.724 132.773 273.724 132.684C273.724 132.598 273.758 132.553 273.796 132.533C273.838 132.511 273.909 132.507 274.004 132.553L286.726 138.683C286.821 138.728 286.91 138.811 286.976 138.909C287.043 139.007 287.08 139.113 287.08 139.202C287.08 139.288 287.046 139.333 287.008 139.353C286.966 139.375 286.895 139.379 286.8 139.333Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M259.12 120.471V107.513V107.459L259.071 107.436L254.92 105.456V105.456L254.871 105.433L238.942 97.835L238.82 97.7768V97.9121V109.976L238.266 110.023V96.8706L254.798 104.756L254.92 104.814V104.679V97.0762L255.474 97.0292V105.024V105.078L255.522 105.101L282.142 117.798V131.005L281.589 131.052V118.23V118.176L281.54 118.153L259.796 107.782L259.674 107.723V107.859V120.424L259.12 120.471Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M299.661 112.909V112.856L299.615 112.833L265.26 95.3396L265.546 94.8338L300.215 112.487V148.536L299.661 148.583V112.909Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M293.799 128.864L293.799 128.864L293.793 128.861C293.465 128.702 293.261 128.371 293.261 127.99V127.98L293.259 127.971L291.995 122.549C291.998 122.523 292.011 122.485 292.043 122.434C292.077 122.379 292.129 122.318 292.196 122.253C292.33 122.123 292.518 121.986 292.726 121.869C292.935 121.753 293.162 121.658 293.373 121.611C293.586 121.563 293.773 121.565 293.911 121.627C293.911 121.627 293.911 121.628 293.912 121.628L308.813 128.834L308.85 128.757L308.813 128.834C309.118 128.982 309.309 129.291 309.309 129.647V135.418C309.26 135.62 309.13 135.817 308.949 135.997C308.765 136.179 308.533 136.34 308.293 136.468C308.052 136.595 307.807 136.689 307.598 136.738C307.493 136.762 307.4 136.775 307.322 136.777C307.245 136.778 307.19 136.768 307.155 136.752L293.799 128.864Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M292.563 122.405L292.563 122.405L307.466 129.612L307.466 129.612C307.771 129.76 307.962 130.069 307.962 130.424V136.206C307.962 136.627 307.506 136.922 307.152 136.751L292.446 129.639C292.119 129.48 291.914 129.149 291.914 128.768V122.842C291.914 122.503 292.281 122.268 292.563 122.405Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M296.852 127.219L296.852 127.219C296.757 127.174 296.667 127.091 296.601 126.993C296.535 126.895 296.498 126.789 296.498 126.7C296.498 126.614 296.532 126.569 296.57 126.549C296.612 126.528 296.682 126.523 296.778 126.569L303.026 129.58C303.121 129.626 303.21 129.708 303.277 129.806C303.343 129.904 303.38 130.01 303.38 130.099C303.38 130.185 303.346 130.23 303.308 130.25C303.267 130.272 303.196 130.276 303.1 130.23L296.852 127.219Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M306.337 133.807L293.614 127.676C293.52 127.631 293.43 127.549 293.364 127.451C293.298 127.352 293.261 127.246 293.261 127.158C293.261 127.071 293.294 127.026 293.333 127.006C293.374 126.985 293.445 126.98 293.54 127.026L306.263 133.157C306.357 133.202 306.447 133.284 306.513 133.382C306.579 133.481 306.617 133.587 306.617 133.675C306.617 133.762 306.583 133.807 306.545 133.827C306.503 133.848 306.432 133.853 306.337 133.807Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M293.799 152.342L293.799 152.341L293.793 152.338C293.465 152.18 293.261 151.849 293.261 151.468V151.458L293.259 151.448L291.995 146.027C291.998 146 292.011 145.962 292.043 145.912C292.077 145.857 292.129 145.796 292.196 145.731C292.33 145.601 292.518 145.464 292.726 145.347C292.935 145.23 293.162 145.136 293.373 145.088C293.586 145.041 293.773 145.043 293.911 145.105C293.911 145.105 293.911 145.105 293.912 145.105L308.813 152.312L308.85 152.235L308.813 152.312C309.118 152.459 309.309 152.768 309.309 153.124V158.896C309.26 159.098 309.13 159.294 308.949 159.474C308.765 159.657 308.533 159.817 308.293 159.945C308.052 160.073 307.807 160.166 307.598 160.215C307.493 160.24 307.4 160.253 307.322 160.254C307.245 160.256 307.19 160.245 307.155 160.229L293.799 152.342Z",
    fill: "#8E9B9A",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M307.152 160.228L307.152 160.228L292.446 153.116C292.119 152.958 291.914 152.627 291.914 152.245V146.319C291.914 145.98 292.281 145.746 292.563 145.882L292.563 145.882L307.466 153.089L307.466 153.089C307.771 153.237 307.962 153.546 307.962 153.902V159.684C307.962 160.105 307.506 160.399 307.152 160.228Z",
    fill: "#BEC6C6",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M296.851 150.699L296.814 150.776L296.851 150.699C296.756 150.653 296.667 150.571 296.6 150.473C296.534 150.375 296.497 150.269 296.497 150.18C296.497 150.094 296.531 150.049 296.569 150.029C296.611 150.007 296.681 150.003 296.777 150.049L303.025 153.06C303.12 153.105 303.21 153.188 303.276 153.285C303.342 153.384 303.379 153.49 303.379 153.579C303.379 153.665 303.345 153.71 303.307 153.73C303.266 153.751 303.195 153.756 303.099 153.71L296.851 150.699Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M306.337 157.287L293.614 151.157C293.52 151.111 293.43 151.029 293.364 150.931C293.298 150.833 293.261 150.727 293.261 150.638C293.261 150.552 293.294 150.507 293.333 150.487C293.374 150.465 293.445 150.461 293.54 150.507L306.263 156.637C306.357 156.683 306.447 156.765 306.513 156.863C306.579 156.961 306.617 157.067 306.617 157.156C306.617 157.242 306.583 157.287 306.545 157.307C306.503 157.328 306.432 157.333 306.337 157.287Z",
    fill: "#E5EAEA",
    stroke: "#608EE5",
    strokeWidth: 0.170711
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M137.481 106.185C137.481 106.185 101.928 117.845 101.105 124.572C100.397 130.348 102.479 169.004 103.08 179.799C103.18 181.582 104.037 183.228 105.436 184.337L127.986 197.054L135.948 163.393C139.83 161.56 142.307 157.652 142.307 153.359L137.481 106.185Z",
    fill: "url(#paint7_linear_3956_9012)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M108.117 181.284L132.178 193.84L138.417 168.242L123.267 173.696L108.117 181.284Z",
    fill: "url(#paint8_linear_3956_9012)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M142.825 108.411C142.825 108.411 107.272 120.072 106.449 126.798C105.625 133.524 108.116 181.284 108.116 181.284L141.292 165.62C145.174 163.787 147.65 159.879 147.65 155.586L142.825 108.411Z",
    fill: "url(#paint9_linear_3956_9012)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M123.719 163.329C123.719 163.329 119.074 172.693 126.966 177.839C134.858 182.985 175.982 182.824 175.982 182.824L174.597 167.181L123.719 163.329Z",
    fill: "#2D2F4F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M152.841 92.1172C152.841 92.1172 156.612 99.2917 153.209 104.986C149.806 110.68 143.989 117.529 143.989 117.529L142.307 98.5974L152.841 92.1172Z",
    fill: "#131E60"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M193.894 237.218L174.849 228.321L148.635 233.483C148.635 233.483 155.955 252.498 165.069 253.313C174.184 254.128 193.894 237.218 193.894 237.218Z",
    fill: "url(#paint10_linear_3956_9012)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M132.875 219.986C132.875 219.986 129.992 232.646 135.961 237.648C141.931 242.65 153.126 247.342 158.191 247.342C161.965 247.342 178.087 237.799 187.293 232.249C189.584 230.868 192.498 232.524 192.498 235.199L196.374 267.186C196.374 267.186 201.584 267.825 205.277 265.835C208.971 263.845 205.841 215.109 205.841 215.109C205.841 215.109 199.621 201.393 187.46 208.303C175.3 215.212 183.803 205.916 175.3 208.303C166.798 210.69 154.916 215.866 154.916 215.866L132.875 219.986Z",
    fill: "#2D2F4F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M250.835 259.93V243.601L261.241 249.681V264.676L250.835 259.93Z",
    fill: "#2D2F4F"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M264.83 293.372C264.83 293.372 264.078 296.259 265.711 297.184C267.344 298.109 269.031 296.694 269.031 296.694L283.145 301.841L269.214 314.792V317.758C269.214 317.758 271.208 320.099 273.603 318.738C275.998 317.377 276.706 315.255 276.706 315.255L290.651 304.695L305.39 314.601C305.39 314.601 305.226 316.398 308.165 317.595C311.104 318.792 315.025 314.656 314.425 313.404C313.826 312.152 298.967 302.137 298.967 302.137L308.982 298.055C308.982 298.055 310.56 298.817 312.737 297.239C314.915 295.66 313.366 292.646 313.366 292.646L295.756 297.838L283.895 284.234C283.895 284.234 281.931 285.373 282.475 287.224C283.019 289.074 283.472 288.965 283.472 288.965L285.142 297.293L264.83 293.372Z",
    fill: "url(#paint11_linear_3956_9012)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M311.232 290.781L293.708 296.232C293.402 296.327 293.075 296.175 292.95 295.881L288.088 284.425C287.99 284.195 287.764 284.046 287.514 284.046H284.336C283.911 284.046 283.611 284.461 283.745 284.864L287.218 295.345C287.371 295.807 286.959 296.257 286.485 296.147L267.506 291.711C267.242 291.649 266.964 291.7 266.738 291.85L265.099 292.944C264.659 293.238 264.762 293.911 265.269 294.059L284.202 299.606C284.669 299.743 284.805 300.339 284.444 300.666L269.414 314.261C269.104 314.541 269.153 315.042 269.513 315.257L271.972 316.723C272.199 316.859 272.487 316.836 272.69 316.667L290.217 302.022C290.433 301.841 290.744 301.828 290.975 301.991L310.514 315.765C310.711 315.904 310.97 315.917 311.179 315.798L314.109 314.142C314.5 313.921 314.536 313.372 314.177 313.103L297.789 300.799C297.401 300.508 297.481 299.904 297.931 299.724L313.13 293.636C313.529 293.476 313.65 292.969 313.366 292.646L311.884 290.964C311.722 290.779 311.466 290.708 311.232 290.781Z",
    fill: "url(#paint12_linear_3956_9012)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M295.023 279.106V299.071C295.023 299.071 294.461 301.02 290.737 300.89C287.014 300.76 286.278 298.985 286.278 298.985V279.106H295.023Z",
    fill: "url(#paint13_linear_3956_9012)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M297.829 272.333V281.075C297.829 281.075 296.905 284.273 290.793 284.06C284.681 283.846 283.473 280.933 283.473 280.933V272.333H297.829Z",
    fill: "url(#paint14_linear_3956_9012)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M252.387 258.577L271.433 249.681L297.647 254.842C297.647 254.842 290.327 273.858 281.212 274.672C272.097 275.487 252.387 258.577 252.387 258.577Z",
    fill: "url(#paint15_linear_3956_9012)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M304.039 233.266C304.039 233.266 305.701 248.707 304.039 250.043C302.378 251.378 285.041 263.364 273.662 260.227C268.479 258.798 245.781 243.365 245.781 243.365L240.94 275.419C240.94 275.419 240.784 278.591 236.271 277.256C231.757 275.92 231.089 271.746 231.089 271.746C231.089 271.746 231.59 227.504 235.096 224.332C238.602 221.16 248.786 225.167 248.786 225.167C248.786 225.167 248.452 217.821 252.793 216.319C257.134 214.816 275.832 225.835 275.832 225.835L304.039 233.266Z",
    fill: "#2D2F4F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.23,
    d: "M294.833 260.687L190.448 209.28C188.37 208.257 185.934 208.264 183.862 209.299L118.605 241.903C117.006 242.702 117.02 244.989 118.629 245.769L225.792 297.676C227.157 298.337 228.753 298.327 230.11 297.649L294.861 265.298C296.769 264.344 296.752 261.617 294.833 260.687Z",
    fill: "#2D2F4F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M294.833 202.194L190.448 150.787C188.37 149.764 185.934 149.771 183.862 150.806L118.605 183.41C117.006 184.209 117.02 186.496 118.629 187.276L225.792 239.183C227.157 239.844 228.753 239.834 230.11 239.156L294.861 206.805C296.769 205.851 296.752 203.124 294.833 202.194Z",
    fill: "url(#paint16_linear_3956_9012)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M294.833 199.731L190.448 148.324C188.37 147.301 185.934 147.308 183.862 148.343L118.605 180.947C117.006 181.746 117.02 184.033 118.629 184.813L225.792 236.72C227.157 237.381 228.753 237.371 230.11 236.693L294.861 204.342C296.769 203.388 296.752 200.66 294.833 199.731Z",
    fill: "url(#paint17_linear_3956_9012)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M117.897 119.144C119.565 114.989 129.597 108.412 129.597 108.412C129.597 108.412 134.823 112.761 138.654 113.605C142.484 114.448 140.827 112.933 140.827 112.933L140.151 111.248C140.151 111.248 154.296 110.84 155.088 113.234C155.251 113.726 169.424 137.338 169.424 137.338L191.325 152.309C191.325 152.309 185.193 155.69 184.303 157.506C183.642 158.855 184.026 159.41 184.266 159.606C182.376 158.41 161.073 144.857 155.885 138.386L156.247 161.765C156.247 161.765 146.134 168.942 137.193 168.187C128.253 167.432 123.72 163.329 123.72 163.329V155.53C123.72 155.53 115.715 157.938 114.613 154.034C113.51 150.131 116.229 123.3 117.897 119.144Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M184.266 159.606C184.354 159.662 184.415 159.701 184.415 159.701C184.415 159.701 184.349 159.674 184.266 159.606Z",
    fill: "url(#paint18_linear_3956_9012)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M206.129 37.244L161.708 15.3916V55.0904L206.129 76.9428V37.244Z",
    fill: "url(#paint19_linear_3956_9012)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M206.129 81.6151L161.708 59.7627V99.4615L206.129 121.314V81.6151Z",
    fill: "url(#paint20_linear_3956_9012)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M237.108 3.83833V19.78L233.362 17.929V1.9873L237.108 3.83833Z",
    fill: "#F4F1EF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M243.554 1.85085V23.0269L239.808 21.1761V0L243.554 1.85085Z",
    fill: "#F4F1EF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M249.999 9.93386V26.2069L246.254 24.3559V8.08301L249.999 9.93386Z",
    fill: "#F4F1EF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M256.445 16.9085V29.5905L252.7 27.7396V15.0576L256.445 16.9085Z",
    fill: "#F4F1EF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M262.891 24.1743V32.9732L259.145 31.1222V22.3232L262.891 24.1743Z",
    fill: "#F4F1EF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M262.891 39.5258L233.362 24.481V21.4775L262.891 36.5223V39.5258Z",
    fill: "#F4F1EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.761 89.2512L183.363 81.4721C182.848 81.2133 182.427 80.5808 182.427 80.0663C182.427 79.5518 182.848 79.3425 183.363 79.6013L198.761 87.3804C199.276 87.6392 199.697 88.2717 199.697 88.7862C199.697 89.3006 199.276 89.5099 198.761 89.2512Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.923 79.0803L172.189 75.7445C171.675 75.4857 171.254 74.8533 171.254 74.3387C171.254 73.8242 171.675 73.6149 172.189 73.8737L178.923 77.2093C179.438 77.4681 179.859 78.1007 179.859 78.6152C179.859 79.1298 179.438 79.3391 178.923 79.0803Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 94.3352L186.642 88.1948C186.127 87.936 185.706 87.3035 185.706 86.7889C185.706 86.2744 186.127 86.0651 186.642 86.3239L198.761 92.4644C199.276 92.7232 199.697 93.3559 199.697 93.8702C199.697 94.3847 199.276 94.594 198.761 94.3352Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.203 85.8037L169.075 79.1908C168.56 78.932 168.139 78.2996 168.139 77.785C168.139 77.2705 168.56 77.0612 169.075 77.32L182.203 83.9329C182.717 84.1917 183.138 84.8241 183.138 85.3387C183.138 85.8532 182.717 86.0625 182.203 85.8037Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 99.4212L183.363 91.642C182.848 91.3832 182.427 90.7507 182.427 90.2362C182.427 89.7217 182.848 89.5124 183.363 89.7712L198.761 97.5503C199.276 97.8091 199.697 98.4416 199.697 98.9561C199.697 99.4707 199.276 99.68 198.761 99.4212Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.923 89.251L172.189 85.9154C171.675 85.6566 171.254 85.024 171.254 84.5096C171.254 83.9951 171.675 83.7858 172.189 84.0446L178.923 87.3803C179.438 87.6391 179.859 88.2716 179.859 88.7861C179.859 89.3005 179.438 89.5096 178.923 89.251Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 104.506L187.577 98.8842C187.063 98.6254 186.642 97.9929 186.642 97.4784C186.642 96.9639 187.063 96.7546 187.577 97.0134L198.761 102.635C199.276 102.894 199.697 103.526 199.697 104.041C199.697 104.555 199.276 104.764 198.761 104.506Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.138 96.493L169.845 89.7045C169.33 89.4457 168.909 88.8132 168.909 88.2987C168.909 87.7842 169.33 87.5749 169.845 87.8337L183.138 94.6222C183.652 94.881 184.073 95.5136 184.073 96.028C184.073 96.5425 183.652 96.7518 183.138 96.493Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.761 109.592L183.363 101.813C182.848 101.554 182.427 100.922 182.427 100.407C182.427 99.8926 182.848 99.6833 183.363 99.9421L198.761 107.721C199.276 107.98 199.697 108.613 199.697 109.127C199.697 109.641 199.276 109.851 198.761 109.592Z",
    fill: "#FEFEFE"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M211.139 207.373L243.898 192.713C244.546 192.394 245.305 192.397 245.95 192.719L266.493 201.507C266.991 201.756 266.772 203.837 266.271 204.08L232.888 220.249C232.463 220.455 231.966 220.452 231.543 220.241L211.372 210.163C210.778 209.866 210.541 207.662 211.139 207.373Z",
    fill: "url(#paint21_linear_3956_9012)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M242.869 190.415L210.899 207.298C210.02 207.725 207.994 206.239 207.994 205.261V179.541C207.994 178.487 208.596 177.526 209.543 177.065L242.111 161.226C243.151 160.72 245.515 161.685 245.515 162.841L244.361 188.03C244.361 189.045 243.782 189.971 242.869 190.415Z",
    fill: "url(#paint22_linear_3956_9012)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M244.25 191.143L211.278 207.179C210.399 207.607 209.375 206.967 209.375 205.989V180.269C209.375 179.215 209.977 178.254 210.925 177.793L243.492 161.954C244.532 161.448 245.742 162.205 245.742 163.361V188.758C245.742 189.773 245.163 190.699 244.25 191.143Z",
    fill: "url(#paint23_linear_3956_9012)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M243.671 189.954C244.126 189.733 244.419 189.264 244.419 188.758V163.362C244.419 163.179 244.253 163.117 244.177 163.117C244.142 163.117 244.107 163.126 244.071 163.143L211.504 178.983C211.015 179.221 210.699 179.726 210.699 180.269V205.99L243.671 189.954Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.482 178.898L240.427 173.553C240.7 173.431 240.923 173.107 240.923 172.834C240.923 172.561 240.7 172.438 240.427 172.56L228.482 177.905C228.209 178.027 227.985 178.351 227.985 178.624C227.985 178.897 228.209 179.02 228.482 178.898Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.051 178.448L231.996 173.103C232.269 172.981 232.492 172.657 232.492 172.384C232.492 172.111 232.269 171.987 231.996 172.11L220.051 177.455C219.778 177.577 219.554 177.901 219.554 178.174C219.554 178.447 219.778 178.57 220.051 178.448Z",
    fill: "url(#paint24_linear_3956_9012)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 185.341L240.516 175.371C240.74 175.27 240.923 175.005 240.923 174.781C240.923 174.556 240.74 174.455 240.516 174.555L218.234 184.526C218.01 184.626 217.827 184.892 217.827 185.116C217.827 185.34 218.01 185.441 218.234 185.341Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 187.003L240.516 177.033C240.74 176.932 240.923 176.667 240.923 176.443C240.923 176.219 240.74 176.117 240.516 176.217L218.234 186.188C218.01 186.289 217.827 186.554 217.827 186.778C217.827 187.002 218.01 187.104 218.234 187.003Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 188.664L240.516 178.694C240.74 178.593 240.923 178.328 240.923 178.104C240.923 177.88 240.74 177.778 240.516 177.879L218.234 187.849C218.01 187.95 217.827 188.215 217.827 188.439C217.827 188.663 218.01 188.765 218.234 188.664Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 190.327L240.516 180.356C240.74 180.255 240.923 179.99 240.923 179.766C240.923 179.542 240.74 179.44 240.516 179.541L218.234 189.511C218.01 189.612 217.827 189.877 217.827 190.101C217.827 190.326 218.01 190.427 218.234 190.327Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 191.988L240.516 182.017C240.74 181.917 240.923 181.651 240.923 181.427C240.923 181.203 240.74 181.101 240.516 181.202L218.234 191.173C218.01 191.273 217.827 191.538 217.827 191.763C217.827 191.987 218.01 192.088 218.234 191.988Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 193.65L240.516 183.679C240.74 183.579 240.923 183.313 240.923 183.089C240.923 182.865 240.74 182.764 240.516 182.864L218.234 192.835C218.01 192.935 217.827 193.201 217.827 193.425C217.827 193.649 218.01 193.75 218.234 193.65Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 195.31L240.516 185.339C240.74 185.239 240.923 184.973 240.923 184.749C240.923 184.525 240.74 184.424 240.516 184.524L218.234 194.495C218.01 194.595 217.827 194.861 217.827 195.085C217.827 195.309 218.01 195.41 218.234 195.31Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.234 196.972L240.516 187.001C240.74 186.901 240.923 186.636 240.923 186.411C240.923 186.187 240.74 186.086 240.516 186.186L218.234 196.157C218.01 196.257 217.827 196.523 217.827 196.747C217.827 196.971 218.01 197.072 218.234 196.972Z",
    fill: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.711 193.05L240.516 188.663C240.74 188.562 240.923 188.297 240.923 188.073C240.923 187.848 240.74 187.747 240.516 187.847L230.711 192.235C230.487 192.335 230.304 192.6 230.304 192.825C230.304 193.049 230.487 193.15 230.711 193.05Z",
    fill: "#D8D2D2"
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M211.381 207.192L243.898 191.178C244.545 190.859 245.304 190.861 245.949 191.184L266.278 201.34C266.776 201.589 266.771 202.302 266.27 202.544L232.888 218.714C232.462 218.92 231.965 218.917 231.543 218.706L211.372 208.628C210.778 208.331 210.783 207.481 211.381 207.192Z",
    fill: "url(#paint25_linear_3956_9012)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M256.405 199.786L227.915 213.514C227.319 213.801 226.623 213.789 226.037 213.482L215.937 208.186C215.57 207.993 215.577 207.465 215.949 207.283L244.329 193.378C245.05 193.024 245.897 193.034 246.61 193.403L256.423 198.483C256.957 198.759 256.946 199.526 256.405 199.786Z",
    fill: "#42527A"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M243.851 194.596L245.625 193.737C245.661 193.72 245.704 193.72 245.741 193.738L246.938 194.282C246.967 194.295 246.97 194.334 246.942 194.347L245.12 195.213C245.097 195.224 245.068 195.224 245.043 195.213L243.857 194.673C243.821 194.657 243.818 194.611 243.851 194.596Z",
    fill: "url(#paint26_linear_3956_9012)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M241.593 195.683L243.367 194.824C243.403 194.807 243.446 194.807 243.483 194.825L244.68 195.369C244.709 195.382 244.712 195.421 244.684 195.433L242.862 196.3C242.839 196.311 242.81 196.311 242.785 196.3L241.599 195.76C241.564 195.744 241.56 195.698 241.593 195.683Z",
    fill: "url(#paint27_linear_3956_9012)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M239.335 196.769L241.109 195.911C241.144 195.894 241.187 195.894 241.225 195.911L242.421 196.456C242.451 196.469 242.453 196.507 242.426 196.52L240.603 197.387C240.58 197.398 240.552 197.398 240.527 197.387L239.34 196.846C239.305 196.831 239.302 196.785 239.335 196.769Z",
    fill: "url(#paint28_linear_3956_9012)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M237.077 197.854L238.851 196.996C238.886 196.979 238.929 196.979 238.967 196.996L240.164 197.541C240.193 197.554 240.196 197.592 240.168 197.605L238.346 198.472C238.322 198.483 238.294 198.483 238.269 198.472L237.083 197.931C237.048 197.915 237.044 197.87 237.077 197.854Z",
    fill: "url(#paint29_linear_3956_9012)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M234.818 198.941L236.593 198.083C236.628 198.066 236.671 198.066 236.709 198.083L237.905 198.628C237.934 198.641 237.937 198.679 237.91 198.692L236.087 199.559C236.064 199.57 236.036 199.57 236.011 199.558L234.824 199.018C234.789 199.002 234.786 198.957 234.818 198.941Z",
    fill: "url(#paint30_linear_3956_9012)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M232.561 200.028L234.335 199.17C234.37 199.153 234.413 199.153 234.451 199.17L235.648 199.715C235.677 199.728 235.68 199.766 235.652 199.779L233.83 200.646C233.806 200.657 233.778 200.657 233.753 200.645L232.567 200.105C232.531 200.089 232.528 200.044 232.561 200.028Z",
    fill: "url(#paint31_linear_3956_9012)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M230.302 201.114L232.077 200.256C232.112 200.239 232.155 200.239 232.193 200.256L233.389 200.801C233.418 200.814 233.421 200.852 233.394 200.865L231.571 201.732C231.548 201.743 231.52 201.743 231.495 201.731L230.308 201.191C230.273 201.175 230.27 201.13 230.302 201.114Z",
    fill: "url(#paint32_linear_3956_9012)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M228.045 202.201L229.819 201.343C229.855 201.326 229.898 201.326 229.936 201.343L231.132 201.888C231.161 201.901 231.164 201.939 231.137 201.952L229.314 202.819C229.291 202.83 229.263 202.83 229.238 202.818L228.051 202.278C228.016 202.262 228.012 202.217 228.045 202.201Z",
    fill: "url(#paint33_linear_3956_9012)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M225.787 203.288L227.561 202.43C227.597 202.413 227.64 202.413 227.677 202.43L228.874 202.974C228.903 202.988 228.906 203.026 228.878 203.039L227.056 203.906C227.032 203.917 227.004 203.917 226.979 203.905L225.792 203.365C225.757 203.349 225.754 203.304 225.787 203.288Z",
    fill: "url(#paint34_linear_3956_9012)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M223.529 204.375L225.303 203.517C225.338 203.5 225.381 203.5 225.419 203.517L226.615 204.061C226.645 204.075 226.647 204.113 226.62 204.126L224.797 204.993C224.774 205.004 224.746 205.004 224.721 204.992L223.534 204.452C223.499 204.436 223.496 204.39 223.529 204.375Z",
    fill: "url(#paint35_linear_3956_9012)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M221.271 205.46L223.045 204.602C223.08 204.584 223.123 204.585 223.161 204.602L224.357 205.146C224.387 205.16 224.39 205.198 224.362 205.211L222.54 206.078C222.516 206.089 222.488 206.088 222.463 206.077L221.276 205.537C221.241 205.521 221.238 205.475 221.271 205.46Z",
    fill: "url(#paint36_linear_3956_9012)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M219.012 206.547L220.787 205.688C220.822 205.671 220.865 205.672 220.903 205.689L222.099 206.233C222.128 206.247 222.131 206.285 222.104 206.298L220.281 207.164C220.258 207.176 220.23 207.175 220.205 207.164L219.018 206.624C218.983 206.608 218.98 206.562 219.012 206.547Z",
    fill: "url(#paint37_linear_3956_9012)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M216.755 207.634L218.529 206.775C218.564 206.758 218.607 206.758 218.645 206.776L219.841 207.32C219.871 207.333 219.873 207.372 219.846 207.385L218.023 208.251C218 208.262 217.972 208.262 217.947 208.251L216.76 207.711C216.725 207.695 216.722 207.649 216.755 207.634Z",
    fill: "url(#paint38_linear_3956_9012)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M245.613 195.53L247.388 194.672C247.423 194.655 247.466 194.655 247.504 194.672L248.7 195.217C248.73 195.23 248.732 195.268 248.705 195.281L246.882 196.148C246.859 196.159 246.831 196.159 246.806 196.147L245.619 195.607C245.584 195.591 245.581 195.546 245.613 195.53Z",
    fill: "url(#paint39_linear_3956_9012)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M243.356 196.617L245.13 195.759C245.165 195.742 245.208 195.742 245.246 195.759L246.442 196.304C246.472 196.317 246.474 196.355 246.447 196.368L244.624 197.235C244.601 197.246 244.573 197.246 244.548 197.234L243.361 196.694C243.326 196.678 243.323 196.633 243.356 196.617Z",
    fill: "url(#paint40_linear_3956_9012)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M241.097 197.703L242.872 196.845C242.907 196.828 242.95 196.828 242.988 196.845L244.184 197.389C244.214 197.403 244.216 197.441 244.189 197.454L242.366 198.321C242.343 198.332 242.315 198.332 242.29 198.32L241.103 197.78C241.068 197.764 241.065 197.719 241.097 197.703Z",
    fill: "url(#paint41_linear_3956_9012)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M238.84 198.789L240.614 197.931C240.649 197.914 240.692 197.914 240.73 197.931L241.926 198.475C241.956 198.489 241.958 198.527 241.931 198.54L240.108 199.407C240.085 199.418 240.057 199.418 240.032 199.406L238.845 198.866C238.81 198.85 238.807 198.805 238.84 198.789Z",
    fill: "url(#paint42_linear_3956_9012)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M236.581 199.876L238.356 199.018C238.391 199.001 238.434 199.001 238.472 199.018L239.668 199.562C239.697 199.576 239.7 199.614 239.673 199.627L237.85 200.494C237.827 200.505 237.799 200.504 237.774 200.493L236.587 199.953C236.552 199.937 236.549 199.891 236.581 199.876Z",
    fill: "url(#paint43_linear_3956_9012)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M234.323 200.962L236.098 200.104C236.133 200.086 236.176 200.087 236.214 200.104L237.41 200.648C237.44 200.662 237.442 200.7 237.415 200.713L235.592 201.579C235.569 201.591 235.541 201.59 235.516 201.579L234.329 201.039C234.294 201.023 234.291 200.977 234.323 200.962Z",
    fill: "url(#paint44_linear_3956_9012)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M232.065 202.049L233.839 201.19C233.875 201.173 233.918 201.174 233.956 201.191L235.152 201.735C235.181 201.748 235.184 201.787 235.157 201.8L233.334 202.666C233.311 202.678 233.283 202.677 233.258 202.666L232.071 202.126C232.036 202.11 232.032 202.064 232.065 202.049Z",
    fill: "url(#paint45_linear_3956_9012)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M229.808 203.136L231.582 202.277C231.617 202.26 231.66 202.26 231.698 202.278L232.894 202.822C232.924 202.835 232.926 202.874 232.899 202.887L231.076 203.753C231.053 203.764 231.025 203.764 231 203.753L229.813 203.213C229.779 203.197 229.775 203.151 229.808 203.136Z",
    fill: "url(#paint46_linear_3956_9012)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M227.549 204.223L229.324 203.364C229.359 203.347 229.402 203.347 229.44 203.365L230.636 203.909C230.666 203.922 230.668 203.961 230.641 203.974L228.818 204.84C228.795 204.851 228.767 204.851 228.742 204.84L227.555 204.3C227.52 204.284 227.517 204.238 227.549 204.223Z",
    fill: "url(#paint47_linear_3956_9012)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M225.292 205.308L227.066 204.449C227.101 204.432 227.144 204.432 227.182 204.45L228.378 204.994C228.408 205.007 228.41 205.046 228.383 205.058L226.56 205.925C226.537 205.936 226.509 205.936 226.484 205.925L225.297 205.385C225.262 205.369 225.259 205.323 225.292 205.308Z",
    fill: "url(#paint48_linear_3956_9012)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M223.033 206.394L224.808 205.536C224.843 205.519 224.886 205.519 224.924 205.536L226.12 206.081C226.15 206.094 226.152 206.132 226.125 206.145L224.302 207.012C224.279 207.023 224.251 207.023 224.226 207.012L223.039 206.471C223.004 206.456 223.001 206.41 223.033 206.394Z",
    fill: "url(#paint49_linear_3956_9012)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M220.776 207.481L222.55 206.623C222.585 206.606 222.628 206.606 222.666 206.623L223.862 207.168C223.892 207.181 223.894 207.219 223.867 207.232L222.044 208.099C222.021 208.11 221.993 208.11 221.968 208.099L220.781 207.558C220.746 207.543 220.743 207.497 220.776 207.481Z",
    fill: "url(#paint50_linear_3956_9012)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M218.517 208.567L220.292 207.709C220.327 207.692 220.37 207.692 220.408 207.709L221.604 208.254C221.633 208.267 221.636 208.305 221.609 208.318L219.786 209.185C219.763 209.196 219.735 209.196 219.71 209.184L218.523 208.644C218.488 208.628 218.485 208.583 218.517 208.567Z",
    fill: "url(#paint51_linear_3956_9012)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M247.376 196.464L249.15 195.605C249.186 195.588 249.229 195.589 249.267 195.606L250.463 196.15C250.492 196.164 250.495 196.202 250.468 196.215L248.645 197.081C248.622 197.093 248.594 197.092 248.569 197.081L247.382 196.541C247.347 196.525 247.343 196.479 247.376 196.464Z",
    fill: "url(#paint52_linear_3956_9012)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M245.119 197.551L246.893 196.692C246.928 196.675 246.971 196.675 247.009 196.693L248.206 197.237C248.235 197.25 248.238 197.289 248.21 197.302L246.388 198.168C246.364 198.179 246.336 198.179 246.311 198.168L245.125 197.628C245.09 197.612 245.086 197.566 245.119 197.551Z",
    fill: "url(#paint53_linear_3956_9012)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M242.861 198.637L244.635 197.778C244.67 197.761 244.713 197.761 244.751 197.779L245.947 198.323C245.977 198.336 245.979 198.375 245.952 198.388L244.129 199.254C244.106 199.265 244.078 199.265 244.053 199.254L242.866 198.714C242.831 198.698 242.828 198.652 242.861 198.637Z",
    fill: "url(#paint54_linear_3956_9012)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M240.603 199.724L242.377 198.865C242.412 198.848 242.455 198.848 242.493 198.866L243.69 199.41C243.719 199.423 243.722 199.462 243.694 199.474L241.872 200.341C241.848 200.352 241.82 200.352 241.795 200.341L240.608 199.801C240.573 199.785 240.57 199.739 240.603 199.724Z",
    fill: "url(#paint55_linear_3956_9012)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M238.344 200.81L240.119 199.952C240.154 199.935 240.197 199.935 240.235 199.952L241.431 200.497C241.46 200.51 241.463 200.548 241.436 200.561L239.613 201.428C239.59 201.439 239.562 201.439 239.537 201.428L238.35 200.887C238.315 200.871 238.312 200.826 238.344 200.81Z",
    fill: "url(#paint56_linear_3956_9012)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M236.087 201.896L237.861 201.038C237.896 201.021 237.939 201.021 237.977 201.038L239.173 201.583C239.203 201.596 239.206 201.634 239.178 201.647L237.356 202.514C237.332 202.525 237.304 202.525 237.279 202.514L236.092 201.973C236.057 201.958 236.054 201.912 236.087 201.896Z",
    fill: "url(#paint57_linear_3956_9012)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M233.828 202.982L235.603 202.124C235.638 202.107 235.681 202.107 235.719 202.124L236.915 202.669C236.944 202.682 236.947 202.72 236.92 202.733L235.097 203.6C235.074 203.611 235.046 203.611 235.021 203.599L233.834 203.059C233.799 203.043 233.796 202.998 233.828 202.982Z",
    fill: "url(#paint58_linear_3956_9012)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M231.57 204.069L233.345 203.211C233.38 203.194 233.423 203.194 233.461 203.211L234.657 203.756C234.686 203.769 234.689 203.807 234.662 203.82L232.839 204.687C232.816 204.698 232.788 204.698 232.763 204.686L231.576 204.146C231.541 204.13 231.538 204.085 231.57 204.069Z",
    fill: "url(#paint59_linear_3956_9012)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M229.312 205.156L231.086 204.298C231.122 204.281 231.165 204.281 231.203 204.298L232.399 204.843C232.428 204.856 232.431 204.894 232.404 204.907L230.581 205.774C230.558 205.785 230.53 205.785 230.505 205.773L229.318 205.233C229.283 205.217 229.28 205.172 229.312 205.156Z",
    fill: "url(#paint60_linear_3956_9012)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M227.054 206.242L228.829 205.384C228.864 205.367 228.907 205.367 228.945 205.384L230.141 205.929C230.17 205.942 230.173 205.98 230.146 205.993L228.323 206.86C228.3 206.871 228.272 206.871 228.247 206.859L227.06 206.319C227.025 206.303 227.022 206.258 227.054 206.242Z",
    fill: "url(#paint61_linear_3956_9012)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M224.796 207.329L226.57 206.471C226.606 206.454 226.649 206.454 226.687 206.471L227.883 207.015C227.912 207.029 227.915 207.067 227.888 207.08L226.065 207.947C226.042 207.958 226.014 207.958 225.989 207.946L224.802 207.406C224.767 207.39 224.763 207.345 224.796 207.329Z",
    fill: "url(#paint62_linear_3956_9012)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M222.539 208.415L224.313 207.557C224.348 207.54 224.391 207.54 224.429 207.557L225.626 208.101C225.655 208.115 225.658 208.153 225.63 208.166L223.808 209.033C223.784 209.044 223.756 209.044 223.731 209.032L222.545 208.492C222.509 208.476 222.506 208.431 222.539 208.415Z",
    fill: "url(#paint63_linear_3956_9012)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M220.28 209.502L222.055 208.644C222.09 208.626 222.133 208.627 222.171 208.644L223.367 209.188C223.396 209.202 223.399 209.24 223.372 209.253L221.549 210.12C221.526 210.131 221.498 210.13 221.473 210.119L220.286 209.579C220.251 209.563 220.248 209.517 220.28 209.502Z",
    fill: "url(#paint64_linear_3956_9012)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M249.14 197.396L250.914 196.538C250.949 196.521 250.992 196.521 251.03 196.538L252.227 197.083C252.256 197.096 252.259 197.134 252.231 197.147L250.409 198.014C250.385 198.025 250.357 198.025 250.332 198.014L249.146 197.473C249.111 197.458 249.107 197.412 249.14 197.396Z",
    fill: "url(#paint65_linear_3956_9012)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M246.882 198.483L248.656 197.625C248.692 197.608 248.735 197.608 248.772 197.625L249.969 198.17C249.998 198.183 250.001 198.221 249.973 198.234L248.151 199.101C248.127 199.112 248.099 199.112 248.074 199.1L246.887 198.56C246.853 198.544 246.849 198.499 246.882 198.483Z",
    fill: "url(#paint66_linear_3956_9012)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M244.624 199.569L246.398 198.711C246.433 198.694 246.476 198.694 246.514 198.711L247.71 199.256C247.74 199.269 247.743 199.307 247.715 199.32L245.893 200.187C245.869 200.198 245.841 200.198 245.816 200.186L244.629 199.646C244.594 199.63 244.591 199.585 244.624 199.569Z",
    fill: "url(#paint67_linear_3956_9012)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M242.366 200.655L244.14 199.797C244.176 199.78 244.219 199.78 244.256 199.797L245.453 200.342C245.482 200.355 245.485 200.393 245.457 200.406L243.635 201.273C243.612 201.284 243.583 201.284 243.558 201.272L242.371 200.732C242.337 200.716 242.333 200.671 242.366 200.655Z",
    fill: "url(#paint68_linear_3956_9012)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M240.108 201.742L241.882 200.884C241.917 200.867 241.96 200.867 241.998 200.884L243.194 201.429C243.224 201.442 243.226 201.48 243.199 201.493L241.376 202.36C241.353 202.371 241.325 202.371 241.3 202.359L240.113 201.819C240.078 201.803 240.075 201.758 240.108 201.742Z",
    fill: "url(#paint69_linear_3956_9012)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M237.85 202.829L239.624 201.971C239.66 201.954 239.703 201.954 239.74 201.971L240.937 202.515C240.966 202.529 240.969 202.567 240.941 202.58L239.119 203.447C239.095 203.458 239.067 203.458 239.042 203.446L237.855 202.906C237.82 202.89 237.817 202.845 237.85 202.829Z",
    fill: "url(#paint70_linear_3956_9012)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M235.592 203.915L237.366 203.057C237.401 203.04 237.444 203.04 237.482 203.057L238.678 203.601C238.707 203.615 238.71 203.653 238.683 203.666L236.86 204.533C236.837 204.544 236.809 204.544 236.784 204.532L235.597 203.992C235.562 203.976 235.559 203.931 235.592 203.915Z",
    fill: "url(#paint71_linear_3956_9012)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M233.334 205.002L235.109 204.144C235.144 204.126 235.187 204.127 235.225 204.144L236.421 204.688C236.45 204.702 236.453 204.74 236.426 204.753L234.603 205.62C234.58 205.631 234.552 205.63 234.527 205.619L233.34 205.079C233.305 205.063 233.302 205.017 233.334 205.002Z",
    fill: "url(#paint72_linear_3956_9012)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M231.076 206.089L232.85 205.23C232.886 205.213 232.929 205.214 232.966 205.231L234.163 205.775C234.192 205.789 234.195 205.827 234.167 205.84L232.345 206.706C232.322 206.718 232.293 206.717 232.268 206.706L231.082 206.166C231.046 206.15 231.043 206.104 231.076 206.089Z",
    fill: "url(#paint73_linear_3956_9012)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M228.818 207.174L230.592 206.315C230.627 206.298 230.67 206.299 230.708 206.316L231.904 206.86C231.934 206.873 231.936 206.912 231.909 206.925L230.086 207.791C230.063 207.802 230.035 207.802 230.01 207.791L228.823 207.251C228.788 207.235 228.785 207.189 228.818 207.174Z",
    fill: "url(#paint74_linear_3956_9012)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M226.56 208.262L228.334 207.403C228.369 207.386 228.412 207.386 228.45 207.404L229.646 207.948C229.676 207.961 229.678 208 229.651 208.013L227.828 208.879C227.805 208.89 227.777 208.89 227.752 208.879L226.565 208.339C226.531 208.323 226.527 208.277 226.56 208.262Z",
    fill: "url(#paint75_linear_3956_9012)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M224.301 209.348L226.076 208.489C226.111 208.472 226.154 208.472 226.192 208.49L227.388 209.034C227.418 209.047 227.42 209.086 227.393 209.099L225.57 209.965C225.547 209.976 225.519 209.976 225.494 209.965L224.307 209.425C224.272 209.409 224.269 209.363 224.301 209.348Z",
    fill: "url(#paint76_linear_3956_9012)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M222.044 210.435L223.818 209.576C223.853 209.559 223.896 209.559 223.934 209.577L225.13 210.121C225.16 210.134 225.162 210.172 225.135 210.185L223.312 211.052C223.289 211.063 223.261 211.063 223.236 211.052L222.049 210.511C222.014 210.496 222.011 210.45 222.044 210.435Z",
    fill: "url(#paint77_linear_3956_9012)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M250.902 198.332L252.676 197.474C252.712 197.457 252.755 197.457 252.793 197.474L253.989 198.018C254.018 198.032 254.021 198.07 253.994 198.083L252.171 198.95C252.148 198.961 252.12 198.961 252.095 198.949L250.908 198.409C250.873 198.393 250.869 198.348 250.902 198.332Z",
    fill: "url(#paint78_linear_3956_9012)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M248.644 199.419L250.418 198.561C250.454 198.543 250.497 198.544 250.535 198.561L251.731 199.105C251.76 199.119 251.763 199.157 251.736 199.17L249.913 200.037C249.89 200.048 249.862 200.047 249.837 200.036L248.65 199.496C248.615 199.48 248.612 199.434 248.644 199.419Z",
    fill: "url(#paint79_linear_3956_9012)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M246.386 200.504L248.16 199.646C248.196 199.628 248.239 199.629 248.276 199.646L249.473 200.19C249.502 200.204 249.505 200.242 249.477 200.255L247.655 201.121C247.632 201.133 247.603 201.132 247.578 201.121L246.392 200.581C246.357 200.565 246.353 200.519 246.386 200.504Z",
    fill: "url(#paint80_linear_3956_9012)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M244.129 201.591L245.903 200.732C245.938 200.715 245.981 200.716 246.019 200.733L247.215 201.277C247.245 201.29 247.247 201.329 247.22 201.342L245.397 202.208C245.374 202.219 245.346 202.219 245.321 202.208L244.134 201.668C244.099 201.652 244.096 201.606 244.129 201.591Z",
    fill: "url(#paint81_linear_3956_9012)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M241.87 202.678L243.644 201.819C243.68 201.802 243.723 201.802 243.761 201.82L244.957 202.364C244.986 202.377 244.989 202.416 244.962 202.429L243.139 203.295C243.116 203.306 243.088 203.306 243.063 203.295L241.876 202.755C241.841 202.739 241.838 202.693 241.87 202.678Z",
    fill: "url(#paint82_linear_3956_9012)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M239.612 203.765L241.387 202.906C241.422 202.889 241.465 202.889 241.503 202.907L242.699 203.451C242.729 203.464 242.731 203.503 242.704 203.516L240.881 204.382C240.858 204.393 240.83 204.393 240.805 204.382L239.618 203.842C239.583 203.826 239.58 203.78 239.612 203.765Z",
    fill: "url(#paint83_linear_3956_9012)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M237.354 204.851L239.128 203.992C239.164 203.975 239.207 203.975 239.245 203.993L240.441 204.537C240.47 204.55 240.473 204.588 240.446 204.601L238.623 205.468C238.6 205.479 238.571 205.479 238.547 205.468L237.36 204.928C237.325 204.912 237.322 204.866 237.354 204.851Z",
    fill: "url(#paint84_linear_3956_9012)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M235.096 205.937L236.871 205.079C236.906 205.062 236.949 205.062 236.987 205.079L238.183 205.624C238.212 205.637 238.215 205.675 238.188 205.688L236.365 206.555C236.342 206.566 236.314 206.566 236.289 206.555L235.102 206.014C235.067 205.999 235.064 205.953 235.096 205.937Z",
    fill: "url(#paint85_linear_3956_9012)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M232.838 207.024L234.612 206.166C234.648 206.149 234.691 206.149 234.729 206.166L235.925 206.711C235.954 206.724 235.957 206.762 235.93 206.775L234.107 207.642C234.084 207.653 234.056 207.653 234.031 207.641L232.844 207.101C232.809 207.085 232.805 207.04 232.838 207.024Z",
    fill: "url(#paint86_linear_3956_9012)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M230.58 208.109L232.354 207.251C232.389 207.234 232.432 207.234 232.47 207.251L233.666 207.796C233.696 207.809 233.699 207.847 233.671 207.86L231.849 208.727C231.825 208.738 231.797 208.738 231.772 208.726L230.585 208.186C230.55 208.17 230.547 208.125 230.58 208.109Z",
    fill: "url(#paint87_linear_3956_9012)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M228.322 209.196L230.096 208.338C230.132 208.321 230.175 208.321 230.213 208.338L231.409 208.883C231.438 208.896 231.441 208.934 231.414 208.947L229.591 209.814C229.568 209.825 229.539 209.825 229.515 209.813L228.328 209.273C228.293 209.257 228.289 209.212 228.322 209.196Z",
    fill: "url(#paint88_linear_3956_9012)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M226.064 210.283L227.838 209.425C227.874 209.408 227.917 209.408 227.955 209.425L229.151 209.97C229.18 209.983 229.183 210.021 229.156 210.034L227.333 210.901C227.31 210.912 227.282 210.912 227.257 210.9L226.07 210.36C226.035 210.344 226.032 210.299 226.064 210.283Z",
    fill: "url(#paint89_linear_3956_9012)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M223.806 211.37L225.58 210.512C225.615 210.495 225.658 210.495 225.696 210.512L226.893 211.056C226.922 211.07 226.925 211.108 226.897 211.121L225.075 211.988C225.051 211.999 225.023 211.999 224.998 211.987L223.812 211.447C223.777 211.431 223.773 211.386 223.806 211.37Z",
    fill: "url(#paint90_linear_3956_9012)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M252.665 199.265L254.439 198.406C254.474 198.389 254.517 198.389 254.555 198.407L255.751 198.951C255.781 198.964 255.784 199.003 255.756 199.016L253.934 199.882C253.91 199.893 253.882 199.893 253.857 199.882L252.67 199.342C252.635 199.326 252.632 199.28 252.665 199.265Z",
    fill: "url(#paint91_linear_3956_9012)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M250.407 200.351L252.181 199.493C252.216 199.476 252.259 199.476 252.297 199.494L253.494 200.038C253.523 200.051 253.526 200.089 253.498 200.102L251.676 200.969C251.652 200.98 251.624 200.98 251.599 200.969L250.412 200.428C250.378 200.413 250.374 200.367 250.407 200.351Z",
    fill: "url(#paint92_linear_3956_9012)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M248.149 201.437L249.923 200.579C249.958 200.562 250.001 200.562 250.039 200.579L251.235 201.124C251.265 201.137 251.268 201.175 251.24 201.188L249.418 202.055C249.394 202.066 249.366 202.066 249.341 202.055L248.154 201.514C248.119 201.499 248.116 201.453 248.149 201.437Z",
    fill: "url(#paint93_linear_3956_9012)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M245.891 202.523L247.665 201.665C247.701 201.648 247.744 201.648 247.781 201.665L248.978 202.21C249.007 202.223 249.01 202.261 248.982 202.274L247.16 203.141C247.136 203.152 247.108 203.152 247.083 203.14L245.897 202.6C245.861 202.584 245.858 202.539 245.891 202.523Z",
    fill: "url(#paint94_linear_3956_9012)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M243.633 203.61L245.407 202.752C245.442 202.735 245.485 202.735 245.523 202.752L246.719 203.297C246.749 203.31 246.751 203.348 246.724 203.361L244.901 204.228C244.878 204.239 244.85 204.239 244.825 204.227L243.638 203.687C243.603 203.671 243.6 203.626 243.633 203.61Z",
    fill: "url(#paint95_linear_3956_9012)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M241.375 204.697L243.149 203.839C243.184 203.822 243.227 203.822 243.265 203.839L244.461 204.384C244.491 204.397 244.493 204.435 244.466 204.448L242.643 205.315C242.62 205.326 242.592 205.326 242.567 205.314L241.38 204.774C241.345 204.758 241.342 204.713 241.375 204.697Z",
    fill: "url(#paint96_linear_3956_9012)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M239.116 205.783L240.891 204.925C240.926 204.908 240.969 204.908 241.007 204.925L242.203 205.47C242.232 205.483 242.235 205.521 242.208 205.534L240.385 206.401C240.362 206.412 240.334 206.412 240.309 206.4L239.122 205.86C239.087 205.844 239.084 205.799 239.116 205.783Z",
    fill: "url(#paint97_linear_3956_9012)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M236.859 206.87L238.633 206.012C238.669 205.995 238.712 205.995 238.749 206.012L239.946 206.556C239.975 206.57 239.978 206.608 239.95 206.621L238.128 207.488C238.105 207.499 238.076 207.499 238.051 207.487L236.865 206.947C236.83 206.931 236.826 206.886 236.859 206.87Z",
    fill: "url(#paint98_linear_3956_9012)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M234.601 207.957L236.375 207.099C236.41 207.082 236.453 207.082 236.491 207.099L237.688 207.643C237.717 207.657 237.72 207.695 237.692 207.708L235.87 208.575C235.846 208.586 235.818 208.586 235.793 208.574L234.606 208.034C234.571 208.018 234.568 207.973 234.601 207.957Z",
    fill: "url(#paint99_linear_3956_9012)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M232.343 209.042L234.117 208.184C234.152 208.167 234.195 208.167 234.233 208.184L235.43 208.728C235.459 208.742 235.462 208.78 235.434 208.793L233.612 209.66C233.588 209.671 233.56 209.67 233.535 209.659L232.348 209.119C232.314 209.103 232.31 209.057 232.343 209.042Z",
    fill: "url(#paint100_linear_3956_9012)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M230.085 210.129L231.859 209.271C231.894 209.253 231.937 209.254 231.975 209.271L233.171 209.815C233.201 209.829 233.203 209.867 233.176 209.88L231.353 210.746C231.33 210.758 231.302 210.757 231.277 210.746L230.09 210.206C230.055 210.19 230.052 210.144 230.085 210.129Z",
    fill: "url(#paint101_linear_3956_9012)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M227.827 211.216L229.601 210.357C229.636 210.34 229.679 210.341 229.717 210.358L230.914 210.902C230.943 210.915 230.946 210.954 230.918 210.967L229.096 211.833C229.073 211.844 229.044 211.844 229.019 211.833L227.832 211.293C227.797 211.277 227.794 211.231 227.827 211.216Z",
    fill: "url(#paint102_linear_3956_9012)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M225.569 212.303L227.343 211.444C227.378 211.427 227.421 211.427 227.459 211.445L228.655 211.989C228.685 212.002 228.687 212.041 228.66 212.054L226.837 212.92C226.814 212.931 226.786 212.931 226.761 212.92L225.574 212.38C225.539 212.364 225.536 212.318 225.569 212.303Z",
    fill: "url(#paint103_linear_3956_9012)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M241.018 208.475L248.074 205.061C248.214 204.993 248.385 204.994 248.536 205.063L253.293 207.228C253.41 207.281 253.421 207.432 253.312 207.484L246.064 210.931C245.972 210.975 245.859 210.974 245.761 210.929L241.041 208.781C240.902 208.718 240.888 208.537 241.018 208.475Z",
    fill: "url(#paint104_linear_3956_9012)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M227.381 216.907V217.955L227.533 218.062V216.994L227.381 216.907Z",
    fill: "#134D87"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M227.765 217.095V218.143L227.917 218.25V217.181L227.765 217.095Z",
    fill: "#134D87"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M228.148 217.282V218.33L228.301 218.437V217.369L228.148 217.282Z",
    fill: "#134D87"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M228.532 217.47V218.518L228.685 218.625V217.556L228.532 217.47Z",
    fill: "#134D87"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M228.916 217.657V218.705L229.069 218.812V217.744L228.916 217.657Z",
    fill: "#134D87"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 217.845V218.893L229.452 219V217.931L229.3 217.845Z",
    fill: "#134D87"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M229.684 218.032V219.08L229.836 219.187V218.119L229.684 218.032Z",
    fill: "#134D87"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M230.067 218.22V219.268L230.22 219.375V218.306L230.067 218.22Z",
    fill: "#134D87"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M212.765 209.673V210.721L212.918 210.828V209.759L212.765 209.673Z",
    fill: "#134D87"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M213.149 209.86V210.909L213.302 211.015V209.947L213.149 209.86Z",
    fill: "#134D87"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M213.533 210.048V211.096L213.685 211.203V210.134L213.533 210.048Z",
    fill: "#134D87"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M213.917 210.235V211.284L214.069 211.39V210.322L213.917 210.235Z",
    fill: "#134D87"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M214.3 210.423V211.471L214.453 211.578V210.509L214.3 210.423Z",
    fill: "#134D87"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M214.684 210.61V211.659L214.837 211.765V210.697L214.684 210.61Z",
    fill: "#134D87"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M215.068 210.798V211.846L215.22 211.953V210.884L215.068 210.798Z",
    fill: "#134D87"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M215.452 210.986V212.034L215.604 212.141V211.073L215.452 210.986Z",
    fill: "#134D87"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M211.372 208.385L231.543 218.462C231.965 218.674 232.462 218.677 232.888 218.471L266.27 202.301C266.48 202.199 266.598 202.014 266.633 201.816C266.683 202.095 266.565 202.4 266.27 202.543L232.888 218.713C232.462 218.919 231.965 218.916 231.543 218.704L211.372 208.627C211.034 208.458 210.897 208.112 210.945 207.79C210.981 208.031 211.119 208.259 211.372 208.385Z",
    fill: "url(#paint105_linear_3956_9012)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M296.03 156.016C296.03 156.016 296.456 166.99 295.217 168.348C293.978 169.705 291.811 170.159 291.811 170.159L291.811 173.261C291.811 173.261 290.865 175.628 286.168 176.036C281.472 176.445 279.708 174.703 279.708 174.703L280.055 166.7C280.055 166.7 279.205 151.846 285.057 151.907C290.909 151.969 296.03 156.016 296.03 156.016Z",
    fill: "url(#paint106_linear_3956_9012)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M248.786 225.167L266.203 233.213L249.175 221.255L248.786 225.167Z",
    fill: "#131E60"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M297.734 152.051C298.976 155.361 297.208 157.421 295.483 158.497C293.758 159.573 293.621 162.948 293.186 162.728C292.75 162.507 292.752 158.717 291.553 159.218C290.353 159.72 290.381 167.396 288.935 168.542C287.49 169.689 280.165 171.248 277.784 169.266C275.402 167.285 271.97 158.171 272.565 154.278C273.161 150.385 275.565 148.349 275.565 148.349C275.565 148.349 278.448 144.669 283.95 144.449C289.452 144.229 296.354 148.37 297.734 152.051Z",
    fill: "#2D2F4F"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M292.775 170.831H301.252C301.252 170.831 310.707 157.652 311.004 154.578C311.3 151.504 308.755 137.007 308.755 137.007C308.755 137.007 309.997 134.255 313.953 135.128C317.909 136.001 318.743 137.884 318.743 137.884C318.743 137.884 321.364 163.932 321.39 166.138C321.415 168.344 305.797 190.452 305.797 190.452V230.03C305.797 230.03 304.996 239.832 289.508 241.612C276.627 243.093 269.837 235.451 269.837 235.451V216.67C269.837 216.67 262.905 229.652 259.249 229.526C255.594 229.4 233.536 217.426 233.536 217.426C233.536 217.426 231.519 213.519 233.536 210.746C235.553 207.972 238.2 207.846 238.2 207.846C238.2 207.846 254.964 216.544 256.854 215.787C258.745 215.031 266.328 185.945 269.154 183.85C271.98 181.755 278.983 177.393 278.983 177.393L279.564 174.502C279.564 174.502 286.101 175.019 292.775 170.831Z",
    fill: "#608EE5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M236.27 208.421C236.27 208.421 234.956 206.636 232.367 205.793C229.778 204.95 227.67 204.228 227.67 204.228C227.67 204.228 226.767 205.471 228.633 206.324C230.5 207.178 230.922 207.419 229.356 207.539C227.79 207.66 223.034 202.903 221.95 203.686C220.866 204.468 222.793 210.008 225.382 211.633C227.971 213.259 233.025 216.109 233.025 216.109C233.025 216.109 232.105 211.29 236.27 208.421Z",
    fill: "url(#paint107_linear_3956_9012)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M309.556 135.993C309.556 135.993 305.77 132.192 304.988 127.773C304.206 123.354 303.871 116.597 303.871 116.597C303.871 116.597 305.881 115.872 306.44 118.552C306.998 121.232 307.371 124.415 308.022 124.415C308.673 124.415 316.525 126.767 317.217 128.333C317.909 129.899 317.909 136.899 317.909 136.899C317.909 136.899 313.509 133.779 309.556 135.993Z",
    fill: "url(#paint108_linear_3956_9012)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M325.862 209.854C325.862 209.854 290.309 221.515 289.486 228.241C288.662 234.968 286.328 279.852 286.328 279.852L319.503 264.188C323.385 262.355 325.862 258.447 325.862 254.154V209.854Z",
    fill: "#9ABB50"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M325.862 209.854L295.714 224.566C292.827 225.974 290.996 228.906 290.996 232.118V272.606C290.996 278.749 284.34 282.584 279.025 279.503L251.957 263.813C251.057 263.291 250.502 262.329 250.502 261.288C250.502 259.074 252.869 257.666 254.814 258.722L279.54 272.148C282.293 273.642 285.643 271.649 285.643 268.517V229.046C285.643 225.874 287.475 222.987 290.346 221.638L317.447 208.904C318.97 208.188 320.712 208.092 322.305 208.637L325.862 209.854Z",
    fill: "#9ABB50"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M181.452 272.013C181.452 272.013 182.204 274.9 180.571 275.826C178.938 276.751 177.251 275.336 177.251 275.336L163.137 280.482L177.068 293.433V296.4C177.068 296.4 175.074 298.74 172.679 297.38C170.284 296.019 169.576 293.896 169.576 293.896L155.632 283.337L140.893 293.243C140.893 293.243 141.056 295.039 138.117 296.237C135.178 297.434 131.257 293.297 131.857 292.046C132.456 290.794 147.315 280.779 147.315 280.779L137.3 276.697C137.3 276.697 135.722 277.459 133.545 275.88C131.367 274.302 132.916 271.288 132.916 271.288L150.526 276.479L162.387 262.876C162.387 262.876 164.351 264.015 163.807 265.865C163.263 267.716 162.81 267.607 162.81 267.607L161.14 275.935L181.452 272.013Z",
    fill: "url(#paint109_linear_3956_9012)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M135.05 269.422L152.575 274.874C152.88 274.969 153.208 274.817 153.333 274.523L158.195 263.067C158.292 262.837 158.518 262.688 158.768 262.688H161.947C162.371 262.688 162.671 263.103 162.538 263.506L159.064 273.986C158.912 274.448 159.323 274.899 159.797 274.788L178.776 270.352C179.041 270.291 179.318 270.341 179.544 270.492L181.183 271.586C181.623 271.879 181.52 272.552 181.013 272.701L162.081 278.248C161.614 278.385 161.477 278.98 161.838 279.307L176.868 292.902C177.178 293.183 177.129 293.684 176.769 293.898L174.311 295.365C174.083 295.5 173.795 295.477 173.593 295.308L156.065 280.663C155.849 280.482 155.538 280.469 155.307 280.632L135.768 294.406C135.571 294.545 135.312 294.558 135.103 294.439L132.173 292.784C131.782 292.563 131.747 292.013 132.106 291.744L148.493 279.44C148.881 279.149 148.801 278.545 148.351 278.365L133.152 272.277C132.753 272.117 132.632 271.61 132.917 271.288L134.399 269.605C134.561 269.421 134.816 269.349 135.05 269.422Z",
    fill: "url(#paint110_linear_3956_9012)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M151.259 257.747V277.712C151.259 277.712 151.822 279.66 155.545 279.53C159.268 279.4 160.004 277.625 160.004 277.625V257.747H151.259Z",
    fill: "url(#paint111_linear_3956_9012)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M148.454 250.975V259.716C148.454 259.716 149.377 262.915 155.49 262.701C161.602 262.488 162.81 259.574 162.81 259.574V250.975H148.454Z",
    fill: "url(#paint112_linear_3956_9012)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M239.677 276.838C239.677 276.838 237.753 278.478 234.482 276.093C231.211 273.709 230.057 272.554 229.672 272.747C229.287 272.939 221.205 270.534 220.147 270.919C219.089 271.304 214.567 274.478 217.165 275.633C219.762 276.787 231.692 284.292 234.867 284.292C238.042 284.292 241.602 282.095 241.794 281.221C241.987 280.347 239.677 276.838 239.677 276.838Z",
    fill: "#131E60"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M181.808 142.691C181.808 142.691 182.992 146.947 182.431 148.006C181.87 149.066 181.808 149.502 181.808 149.502C181.808 149.502 182.872 150.436 182.9 152.181C182.929 153.926 183.054 161.777 180.624 162.338C178.194 162.898 175.763 162.088 175.14 164.269C174.517 166.45 173.146 170.126 173.146 170.126L160.996 163.708C160.996 163.708 161.931 163.085 162.242 159.035C162.554 154.985 168.66 142.607 168.66 142.607L181.808 142.691Z",
    fill: "url(#paint113_linear_3956_9012)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M159.517 162.88C159.517 162.88 149.004 162.078 146.602 168.752C144.201 175.427 143.764 192.938 144.985 194.57C146.207 196.201 148.932 196.352 148.932 196.352L159.517 162.88Z",
    fill: "#608EE5"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M183.615 141.651C182.874 144.616 177.384 146.018 177.82 148.383C178.256 150.748 178.318 152.244 177.134 152.618C175.951 152.992 177.446 155.755 176.511 156.367C175.577 156.979 175.078 152.057 173.458 152.618C171.838 153.178 174.081 157.852 173.458 160.032C172.835 162.213 164.112 161.68 162.741 158.551C161.37 155.422 158.192 150.942 157.382 146.141C156.572 141.339 163.239 138.267 168.349 136.999C173.458 135.732 179.004 133.296 180.001 132.551C180.998 131.806 185.048 135.919 183.615 141.651Z",
    fill: "#2D2F4F"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M160.865 162.909C160.865 162.909 173.857 167.406 177.921 171.178C181.984 174.951 181.404 183.194 175.134 199.331C168.865 215.469 168.052 223.364 168.052 223.364C168.052 223.364 165.266 227.427 154.121 228.24C142.975 229.053 132.875 219.987 132.875 219.987C132.875 219.987 141.117 189.695 143.904 182.961C146.69 176.228 146.797 161.137 160.865 162.909Z",
    fill: "url(#paint114_linear_3956_9012)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M175.31 176.34C174.107 176.842 172.825 177.624 171.613 178.832C172.644 177.607 173.984 176.83 175.31 176.34Z",
    fill: "#608EE5"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M199.337 211.957C199.306 211.832 199.285 211.767 199.285 211.767C199.285 211.767 185.896 179.535 180.505 175.522C180.505 175.522 183.599 175.039 185.384 174.199C187.17 173.361 190.726 174.199 190.726 174.199C190.726 174.199 197.701 196.42 199.272 206.579C199.611 208.775 199.603 210.547 199.337 211.957Z",
    fill: "#608EE5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M182.161 175.201C182.161 175.201 176.787 167.384 176.741 165.533C176.695 163.683 177.574 158.408 178.453 158.13C179.332 157.853 179.213 163.118 179.471 162.989C179.729 162.86 181.981 162.056 182.372 159.903C182.763 157.751 182.481 156.742 182.942 156.742C183.404 156.742 185.717 159.333 185.903 163.174C186.088 167.014 187.042 173.826 187.042 173.826C187.042 173.826 183.215 174.573 182.161 175.201Z",
    fill: "url(#paint115_linear_3956_9012)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M199.337 211.957V211.959C198.372 217.078 194.021 217.472 190.574 216.284C186.176 214.768 181.323 208.703 177.229 202.94C173.136 197.178 168.13 187.473 170.254 181.256C170.582 180.297 171.051 179.498 171.613 178.832C172.825 177.623 174.107 176.841 175.311 176.34C175.314 176.338 175.317 176.338 175.321 176.336C177.762 175.437 180.15 175.505 180.469 175.518C180.478 175.52 180.485 175.52 180.49 175.52C180.5 175.522 180.505 175.522 180.505 175.522C185.896 179.535 199.285 211.767 199.285 211.767C199.285 211.767 199.306 211.832 199.337 211.957Z",
    fill: "#608EE5"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M175.321 176.336C178.001 175.22 180.28 175.491 180.49 175.52C180.275 175.51 177.826 175.413 175.321 176.336Z",
    fill: "#608EE5"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M120.42 188.493C120.42 188.493 155.972 200.154 156.796 206.88C157.619 213.606 159.954 258.491 159.954 258.491L126.778 242.827C122.896 240.994 120.42 237.086 120.42 232.793V188.493Z",
    fill: "#9ABB50"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M120.42 188.493L150.568 203.205C153.455 204.614 155.286 207.545 155.286 210.757V251.245C155.286 257.389 161.942 261.224 167.257 258.143L194.325 242.453C195.225 241.931 195.78 240.968 195.78 239.927C195.78 237.714 193.413 236.306 191.468 237.362L166.742 250.787C163.989 252.282 160.639 250.289 160.639 247.157V207.685C160.639 204.513 158.806 201.627 155.935 200.278L128.835 187.544C127.312 186.828 125.569 186.732 123.977 187.277L120.42 188.493Z",
    fill: "#9ABB50"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M203.813 265.979C203.813 265.979 212.354 265.655 213.879 265.979C215.405 266.303 218.637 268.996 216.931 269.444C215.226 269.893 200.686 273.304 199.429 273.394C198.172 273.483 195.3 270.97 195.3 270.97L196.495 266.826C196.495 266.826 201.286 267.809 203.813 265.979Z",
    fill: "#131E60"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M151.046 93.5295C151.046 93.5295 152.328 100.503 151.82 102.14C151.312 103.777 149.916 109.245 148.957 110.035C147.997 110.825 145.102 109.987 145.102 109.987L145.238 113.521C145.238 113.521 143.861 115.427 139.854 115.144C135.847 114.862 133.718 111.128 133.718 111.128C133.718 111.128 134.564 96.997 136.709 93.8363C138.854 90.6755 144.78 90.5059 144.78 90.5059L151.046 93.5295Z",
    fill: "url(#paint116_linear_3956_9012)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M154.389 92.4168C154.775 97.4405 151.396 98.5871 148.139 98.8888C144.882 99.1903 139.565 96.8874 139.565 96.8874C139.565 96.8874 142.033 103.333 138.535 105.625C135.037 107.916 134.744 108.432 134.564 110.904C134.383 113.377 131.665 113.651 129.072 115.279C126.479 116.908 125.393 122.215 125.393 122.215C125.393 122.215 118.699 117.149 119.664 110.937C120.629 104.725 127.564 103.037 128.288 99.5388C129.012 96.041 126.851 88.2371 131.786 85.2457C141.265 79.5007 153.786 84.5767 154.389 92.4168Z",
    fill: "#2D2F4F"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.841 113.942C152.841 113.942 157.068 119.239 156.856 122.841C156.644 126.443 155.885 138.386 155.885 138.386L163.68 145.392C163.68 145.392 157.757 141.593 157.315 137.344C156.873 133.095 159.928 126.603 158.099 122.789C156.271 118.975 152.841 113.942 152.841 113.942Z",
    fill: "#131E60"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M122.224 115.885C122.224 115.885 127.281 120.876 126.435 130.582C125.59 140.287 124.305 142.969 124.039 144.011C123.774 145.054 120.251 151.113 120.251 151.113C120.251 151.113 125.042 145.224 127.156 144.011C129.269 142.799 142.233 132.547 142.233 132.547C142.233 132.547 127.156 142.799 126.733 141.813C126.31 140.826 130.96 119.267 122.224 115.885Z",
    fill: "#131E60"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M123.719 155.528L137.325 146.622C137.325 146.622 127.218 153.721 126.233 156.457C125.248 159.193 125.738 164.731 125.738 164.731L123.719 163.327V155.528Z",
    fill: "#131E60"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M142.233 132.547C142.233 132.547 141.554 133.146 143.524 135.664C145.493 138.182 147.354 137.964 147.354 137.964C147.354 137.964 149.489 133.084 150.938 133.499C152.388 133.915 156.008 133.477 154.745 130.194C153.482 126.911 152.841 125.722 152.841 125.722C152.841 125.722 156.161 124.328 156.848 122.217C157.535 120.106 148.995 124.315 146.806 125.722C144.618 127.13 142.233 132.547 142.233 132.547Z",
    fill: "url(#paint117_linear_3956_9012)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M184.709 156.936C184.709 156.936 185.928 160.717 187.72 161.724C189.511 162.732 191.325 163.964 191.325 163.964C191.325 163.964 193.587 163.628 191.325 161.613C189.063 159.597 188.279 157.537 190.183 158.343C192.087 159.149 195.11 164.372 197.125 163.328C199.141 162.284 202.011 160.099 197.833 156.937C193.654 153.774 191.325 152.767 191.325 152.767C191.325 152.767 185.506 153.604 184.709 156.936Z",
    fill: "url(#paint118_linear_3956_9012)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M164.456 47.8054C164.456 47.8054 168.107 37.0109 173.663 43.0432C179.219 49.0753 182.552 34.1537 188.425 47.8054C194.299 61.457 202.236 44.5081 202.236 44.5081",
    stroke: "#FEFEFE",
    strokeWidth: 1.02427,
    strokeMiterlimit: 10
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M417.206 140.131V189.79C417.206 190.16 416.884 190.331 416.665 190.331C416.589 190.331 416.513 190.312 416.428 190.274L410.114 187.302L386.756 176.298L355.461 161.561L343.649 155.997C342.975 155.684 342.539 154.991 342.539 154.241V103.785C342.539 103.243 342.985 102.911 343.403 102.911C343.526 102.911 343.649 102.94 343.773 102.997L345.89 103.993L348.463 105.209L362.924 112.017L381.05 120.553L404.198 131.453L406.895 132.726L414.899 136.495C416.304 137.15 417.206 138.584 417.206 140.131Z",
    fill: "url(#paint119_linear_3956_9012)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 148.995L383.621 138.156C383.11 137.899 382.692 137.271 382.692 136.76C382.692 136.25 383.11 136.042 383.621 136.299L405.177 147.138C405.688 147.395 406.106 148.023 406.106 148.534C406.106 149.045 405.688 149.252 405.177 148.995Z",
    fill: "#DFE1E5"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 153.933L383.621 143.093C383.11 142.836 382.692 142.208 382.692 141.698C382.692 141.187 383.11 140.979 383.621 141.236L405.177 152.076C405.688 152.333 406.106 152.961 406.106 153.471C406.106 153.982 405.688 154.19 405.177 153.933Z",
    fill: "#DFE1E5"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 158.87L383.621 148.031C383.11 147.774 382.692 147.146 382.692 146.635C382.692 146.125 383.11 145.917 383.621 146.174L405.177 157.013C405.688 157.27 406.106 157.898 406.106 158.409C406.106 158.919 405.688 159.127 405.177 158.87Z",
    fill: "#DFE1E5"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 163.808L383.621 152.968C383.11 152.711 382.692 152.083 382.692 151.573C382.692 151.062 383.11 150.854 383.621 151.111L405.177 161.951C405.688 162.208 406.106 162.836 406.106 163.346C406.106 163.857 405.688 164.065 405.177 163.808Z",
    fill: "#DFE1E5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 168.745L383.621 157.906C383.11 157.649 382.692 157.021 382.692 156.51C382.692 156 383.11 155.792 383.621 156.049L405.177 166.888C405.688 167.145 406.106 167.773 406.106 168.284C406.106 168.795 405.688 169.002 405.177 168.745Z",
    fill: "#DFE1E5"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M405.177 173.683L383.621 162.843C383.11 162.586 382.692 161.958 382.692 161.448C382.692 160.937 383.11 160.729 383.621 160.986L405.177 171.826C405.688 172.083 406.106 172.711 406.106 173.221C406.106 173.732 405.688 173.94 405.177 173.683Z",
    fill: "#DFE1E5"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M380.199 162.803L353.64 149.327L353.64 119.448L380.199 132.924L380.199 162.803Z",
    fill: "#DFE1E5"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M353.64 140.659L364.27 133.146L368.254 146.063L375.083 141.683L380.199 149.993V162.803L353.64 149.327V140.659Z",
    fill: "#618FE6"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M377.191 137.624C377.191 139.334 375.805 140.077 374.095 139.284C372.385 138.49 370.999 136.46 370.999 134.75C370.999 133.04 372.385 132.297 374.095 133.09C375.805 133.884 377.191 135.914 377.191 137.624Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M412.012 141.719L346.096 110.677V109.673L412.012 140.715V141.719Z",
    fill: "url(#paint120_linear_3956_9012)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M374.591 94.9189L393.703 125.484C393.703 125.484 394.324 128.945 389.536 132.244C384.748 135.542 380.758 133.716 380.758 133.716L359.203 101.599L374.591 94.9189Z",
    fill: "#6A6E89"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M369.616 102.943C373.636 100.536 375.716 96.6138 374.26 94.1818C372.804 91.7498 368.364 91.7294 364.344 94.1362C360.323 96.543 358.244 100.466 359.699 102.898C361.155 105.33 365.595 105.35 369.616 102.943Z",
    fill: "#525575"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M359.931 79.5225L370.499 96.3223C370.499 96.3223 370.827 98.1452 368.305 99.8827C365.783 101.62 363.682 100.658 363.682 100.658L351.826 83.0408L359.931 79.5225Z",
    fill: "#6A6E89"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M313.377 41.7947C313.334 56.9052 323.96 75.3171 337.116 82.9124C344.848 87.3765 351.73 87.1046 356.099 83.0526C356.526 82.7523 356.935 82.4213 357.324 82.0604C357.752 81.7601 358.161 81.4291 358.55 81.0682C362.344 78.406 364.662 73.3335 364.682 66.3164C364.725 51.1997 354.098 32.7936 340.948 25.2014C333.212 20.7349 326.328 21.0048 321.959 25.0575C321.531 25.3578 321.122 25.6888 320.733 26.0498C320.305 26.3499 319.897 26.6811 319.507 27.042C315.714 29.7036 313.397 34.7759 313.377 41.7947ZM355.006 78.5149C351.26 80.3024 346.273 79.8371 340.802 76.6784C329.212 69.987 319.851 53.7667 319.888 40.4545C319.901 35.8075 321.06 32.1321 323.052 29.5953C326.799 27.8078 331.788 28.2745 337.262 31.4349C348.846 38.1236 358.208 54.3389 358.171 67.6565C358.158 72.3024 356.998 75.9778 355.006 78.5149Z",
    fill: "#525575"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M313.378 41.794C313.334 56.905 323.96 75.315 337.116 82.9114C350.265 90.5019 360.962 84.4032 361.006 69.2922C361.023 62.4402 358.851 54.9109 355.24 48.0181C355.21 47.9568 355.178 47.8984 355.146 47.8372C353.482 44.6841 351.517 41.6683 349.325 38.9153C345.795 34.4747 341.673 30.7204 337.27 28.1775C324.115 20.5812 313.419 26.677 313.378 41.794ZM316.212 43.4289C316.227 37.0002 318.434 32.4226 322.016 30.1629C325.85 27.7369 331.265 27.9704 337.262 31.4328C348.846 38.1213 358.209 54.3389 358.171 67.6544C358.156 72.8918 356.688 76.9032 354.203 79.4314C350.379 83.3289 344.148 83.7084 337.124 79.6533C325.534 72.9619 316.175 56.7415 316.212 43.4289Z",
    fill: "#C2C4C6"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M318.049 41.9441C318.012 55.2537 327.374 71.4742 338.964 78.1656C344.955 81.6251 350.367 81.8588 354.204 79.4326C356.688 76.9044 358.157 72.893 358.171 67.6556C358.209 54.3399 348.846 38.1225 337.262 31.434C331.266 27.9715 325.85 27.738 322.017 30.1641C319.533 32.6924 318.064 36.7036 318.049 41.9441Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M302.021 51.4102L310.778 77.4191L336.152 55.6095L344.258 81.0515",
    stroke: "#525575",
    strokeWidth: 0.512134,
    strokeMiterlimit: 10
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M305.103 49.4985C305.086 49.4689 305.068 49.4384 305.051 49.409C304.326 48.1915 303.29 47.079 302.138 46.389C300.816 45.5968 299.646 45.5419 298.924 46.1032L297.935 46.7756L298.407 46.7655C298.253 47.0964 298.169 47.5025 298.169 47.9786C298.169 49.0387 298.584 50.2496 299.262 51.3677C299.37 51.5468 299.484 51.7237 299.606 51.8963C300.035 52.511 300.541 53.082 301.096 53.5646C301.345 53.782 301.603 53.9807 301.869 54.1575C301.929 54.1968 301.988 54.235 302.048 54.2733C302.078 54.2919 302.108 54.3103 302.138 54.3279C302.168 54.3453 302.199 54.3639 302.228 54.3813C302.288 54.4151 302.347 54.4479 302.407 54.4807C302.988 54.7897 303.534 54.9546 304.02 54.9819C304.09 54.9863 304.159 54.9873 304.225 54.9863C304.38 54.9831 304.225 55.3158 304.366 55.283C304.487 55.2557 305.041 54.9179 305.15 54.8687C305.827 54.5641 306.108 53.7983 306.108 52.7392C306.108 51.7269 305.729 50.575 305.103 49.4985Z",
    fill: "#C2C4C6"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M304.093 50.0561C303.368 48.8387 302.332 47.726 301.18 47.036C298.989 45.7226 297.211 46.4332 297.211 48.6259C297.211 49.686 297.626 50.8968 298.304 52.015C298.412 52.1941 298.527 52.3709 298.648 52.5435C299.077 53.1582 299.584 53.7293 300.139 54.2119C300.388 54.4292 300.645 54.6279 300.912 54.8048C300.972 54.844 301.031 54.8823 301.091 54.9205C301.12 54.9391 301.151 54.9575 301.18 54.9751C301.211 54.9925 301.241 55.0111 301.271 55.0286C301.331 55.0624 301.39 55.0951 301.45 55.1279C302.114 55.4816 302.733 55.6455 303.268 55.6334C303.423 55.6301 303.571 55.6126 303.712 55.58C303.834 55.5526 303.948 55.5134 304.057 55.4642C304.734 55.1597 305.15 54.4456 305.15 53.3865C305.15 52.3457 304.75 51.1578 304.093 50.0561Z",
    fill: "#E2E2E2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M347.702 81.186C347.685 81.1564 347.667 81.1259 347.65 81.0965C346.925 79.879 345.889 78.7665 344.737 78.0765C343.415 77.2844 342.245 77.2294 341.523 77.7907L340.534 78.4631L341.006 78.453C340.852 78.7839 340.768 79.19 340.768 79.6661C340.768 80.7262 341.183 81.9371 341.861 83.0552C341.969 83.2343 342.083 83.4112 342.205 83.5838C342.634 84.1985 343.14 84.7695 343.695 85.2521C343.944 85.4695 344.202 85.6682 344.468 85.845C344.528 85.8843 344.587 85.9225 344.647 85.9608C344.676 85.9794 344.707 85.998 344.737 86.0154C344.767 86.0328 344.798 86.0514 344.827 86.0688C344.887 86.1026 344.946 86.1354 345.006 86.1682C345.587 86.4772 346.133 86.6421 346.619 86.6694C346.689 86.6738 346.758 86.6748 346.824 86.6738C346.979 86.6706 346.824 87.0033 346.965 86.9705C347.086 86.9432 347.64 86.6054 347.749 86.5562C348.426 86.2515 348.707 85.4858 348.707 84.4267C348.707 83.4144 348.328 82.2625 347.702 81.186Z",
    fill: "#6ABE52"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M346.692 81.7436C345.967 80.5262 344.931 79.4135 343.779 78.7235C341.588 77.4101 339.81 78.1207 339.81 80.3134C339.81 81.3735 340.225 82.5843 340.903 83.7025C341.011 83.8816 341.126 84.0584 341.247 84.231C341.676 84.8457 342.183 85.4168 342.737 85.8994C342.986 86.1167 343.244 86.3154 343.51 86.4923C343.57 86.5315 343.629 86.5698 343.689 86.608C343.719 86.6266 343.75 86.645 343.779 86.6626C343.809 86.68 343.84 86.6986 343.87 86.7161C343.93 86.7499 343.989 86.7826 344.049 86.8154C344.713 87.1691 345.332 87.333 345.867 87.3209C346.022 87.3176 346.17 87.3001 346.311 87.2675C346.432 87.2401 346.547 87.2009 346.656 87.1517C347.333 86.8472 347.749 86.1331 347.749 85.074C347.749 84.0332 347.348 82.8452 346.692 81.7436Z",
    fill: "#1A70D3"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M316.87 75.8509C316.843 75.8052 316.816 75.7577 316.789 75.7118C315.663 73.8208 314.054 72.0927 312.264 71.0208C310.212 69.7905 308.394 69.7051 307.273 70.577L305.737 71.6215L306.469 71.6058C306.23 72.1197 306.1 72.7505 306.1 73.4902C306.1 75.1368 306.744 77.0177 307.797 78.7544C307.965 79.0325 308.143 79.3073 308.332 79.5752C308.998 80.5299 309.785 81.417 310.647 82.1666C311.033 82.504 311.434 82.8127 311.847 83.0874C311.941 83.1485 312.032 83.2077 312.126 83.2671C312.171 83.296 312.219 83.3248 312.265 83.352C312.312 83.3791 312.36 83.408 312.405 83.4351C312.499 83.4877 312.59 83.5386 312.684 83.5894C313.586 84.0693 314.434 84.3255 315.188 84.3679C315.297 84.3747 315.404 84.3764 315.507 84.3747C315.748 84.3696 315.506 84.8863 315.725 84.8355C315.914 84.7931 316.774 84.2682 316.944 84.1919C317.995 83.7187 318.431 82.5293 318.431 80.8843C318.431 79.3123 317.842 77.523 316.87 75.8509Z",
    fill: "#6ABE52"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M315.302 76.7176C314.176 74.8266 312.566 73.0985 310.777 72.0266C307.373 69.9865 304.612 71.0905 304.612 74.496C304.612 76.1428 305.257 78.0235 306.31 79.7602C306.478 80.0383 306.656 80.3131 306.844 80.581C307.51 81.5358 308.297 82.4228 309.159 83.1724C309.546 83.5099 309.946 83.8185 310.36 84.0932C310.453 84.1543 310.545 84.2135 310.638 84.273C310.684 84.3018 310.731 84.3307 310.777 84.3578C310.824 84.3849 310.872 84.4138 310.918 84.4409C311.011 84.4935 311.103 84.5444 311.196 84.5953C312.227 85.1448 313.189 85.3991 314.02 85.3805C314.261 85.3754 314.491 85.3483 314.71 85.2974C314.898 85.2551 315.076 85.1939 315.246 85.1176C316.297 84.6444 316.943 83.5353 316.943 81.8903C316.943 80.274 316.321 78.4288 315.302 76.7176Z",
    fill: "#1A70D3"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M341.476 53.3308C341.447 53.2822 341.418 53.2316 341.39 53.183C340.193 51.1729 338.482 49.3358 336.58 48.1965C334.398 46.8887 332.466 46.798 331.274 47.7248L329.641 48.8351L330.42 48.8184C330.166 49.3647 330.027 50.0351 330.027 50.8214C330.027 52.5718 330.712 54.571 331.831 56.4171C332.01 56.7128 332.199 57.0049 332.399 57.2896C333.108 58.3045 333.944 59.2475 334.86 60.0442C335.271 60.4029 335.697 60.731 336.137 61.0231C336.236 61.088 336.333 61.1511 336.432 61.2141C336.481 61.2448 336.532 61.2754 336.58 61.3042C336.631 61.3331 336.681 61.3637 336.73 61.3927C336.829 61.4485 336.926 61.5026 337.025 61.5567C337.984 62.0668 338.886 62.3391 339.688 62.3842C339.804 62.3913 339.917 62.3932 340.027 62.3913C340.283 62.3859 340.026 62.9352 340.259 62.8811C340.459 62.836 341.374 62.2782 341.554 62.1971C342.672 61.6941 343.135 60.4299 343.135 58.6813C343.135 57.0102 342.509 55.1083 341.476 53.3308Z",
    fill: "#C2C4C6"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M339.809 54.2514C338.611 52.2413 336.901 50.4043 334.999 49.2649C331.381 47.0962 328.446 48.2699 328.446 51.8898C328.446 53.6403 329.131 55.6395 330.25 57.4855C330.429 57.7812 330.618 58.0733 330.818 58.3581C331.527 59.3729 332.363 60.3158 333.279 61.1126C333.69 61.4713 334.116 61.7994 334.556 62.0915C334.655 62.1564 334.752 62.2195 334.851 62.2825C334.9 62.3133 334.95 62.3438 334.999 62.3727C335.05 62.4015 335.1 62.4322 335.149 62.4611C335.248 62.5169 335.345 62.571 335.444 62.6252C336.541 63.2093 337.563 63.4797 338.446 63.4598C338.702 63.4543 338.947 63.4254 339.18 63.3713C339.38 63.3263 339.569 63.2614 339.749 63.1803C340.867 62.6774 341.554 61.4983 341.554 59.7497C341.554 58.0318 340.892 56.0703 339.809 54.2514Z",
    fill: "#E2E2E2"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M396.487 281.481C396.487 281.481 429.153 290.832 428.683 295.362C428.212 299.892 366.536 295.362 368.898 288.422C371.261 281.481 371.26 281.481 371.26 281.481H396.487Z",
    fill: "url(#paint121_linear_3956_9012)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M398.148 242.956C398.148 242.956 393.785 232.704 403.821 229.449C413.856 226.195 420.796 229.278 420.796 229.278C420.796 229.278 420.684 240.97 412.065 243.88C403.447 246.79 398.148 242.956 398.148 242.956Z",
    fill: "#9ABB50"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.09 228.146C416.09 228.146 414.99 228.766 416.09 231.164C417.189 233.562 420.191 233.634 420.191 233.634",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.513 227.995C411.513 227.995 411.203 229.07 412.531 231.912C413.859 234.753 419.109 236.936 419.109 236.936",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.857 228.628C407.857 228.628 406.295 231.176 407.857 234.424C409.419 237.672 417.163 240.248 417.163 240.248",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.389 230.553C402.389 230.553 401.558 232.376 404.378 236.463C407.199 240.55 414.845 242.465 414.845 242.465",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.35 233.477C398.35 233.477 398.433 236.694 401.007 239.526C403.581 242.359 409.32 244.613 409.32 244.613",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.147 242.952C401.999 237.683 407.837 232.704 416.605 230.698",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M367.5 254.634L367.537 254.99C368.065 257.913 375.041 260.21 383.589 260.21C392.137 260.21 399.126 257.913 399.654 254.99L399.691 254.634C399.691 251.551 392.481 249.058 383.589 249.058C374.697 249.058 367.5 251.551 367.5 254.634Z",
    fill: "url(#paint122_linear_3956_9012)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M367.538 254.989L370.976 285.398C370.976 287.805 376.626 289.771 383.59 289.771C390.553 289.771 396.203 287.805 396.203 285.398L399.654 254.989C399.126 257.912 392.137 260.209 383.59 260.209C375.042 260.209 368.066 257.912 367.538 254.989Z",
    fill: "url(#paint123_linear_3956_9012)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M391.037 259.58C391.037 259.58 392.314 250.933 398.147 242.953",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M380.626 260.114C380.626 260.114 380.031 228.988 371.657 225.313",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M388.326 259.964C388.326 259.964 390.739 217.515 393.15 216.233",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M364.728 250.275C364.728 250.275 377.536 241.52 378.55 232.581C379.563 223.642 371.658 224.564 371.658 224.564C371.658 224.564 366.293 221.154 361.409 227.144C356.525 233.134 361.502 247.232 364.728 250.275Z",
    fill: "#608EE5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M389.872 195.66C389.872 195.66 380.245 187.997 392.822 182.586C405.398 177.174 417.594 182.975 417.594 182.975C417.594 182.975 409.605 198.867 400.179 200.824C390.753 202.781 389.872 195.66 389.872 195.66Z",
    fill: "#9ABB50"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M389.582 195.411C389.252 196.616 385.586 260.115 385.586 260.115",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M390.058 216.838C390.058 216.838 392.125 209.441 400.592 213.287C409.06 217.133 410.709 233.477 410.709 233.477C410.709 233.477 392.974 233.12 387.184 226.111C381.393 219.102 390.058 216.838 390.058 216.838Z",
    fill: "#608EE5"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M362.714 182.171C362.714 182.171 370.469 182.681 377.781 190.72C385.094 198.759 387.908 205.251 381.71 206.331C381.71 206.331 377.586 214.475 370.364 206.331C363.143 198.187 361.141 182.671 362.714 182.171Z",
    fill: "#608EE5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M383.59 260.209C383.59 260.209 386.27 214.396 381.143 205.071",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.44
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.658 224.564L364.728 250.275",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.307 233.937L370.626 228.393L359.718 230.816",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.69 239.527L369.132 233.937L359.718 236.464",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.097 243.924L367.538 239.852L360.509 241.708",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.581 246.628L366.303 244.432L362.001 245.859",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.057 216.838C390.057 216.838 401.571 219.718 410.708 233.477",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.439 227.38C387.213 223.577 391.624 217.357 391.624 217.357C391.624 217.357 396.755 212.625 400.592 213.287",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.959 229.616C390.767 223.556 395.785 219.316 395.785 219.316C395.785 219.316 400.975 215.966 405.594 217.84",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.467 231.32C395.324 227.47 399.489 221.675 399.489 221.675C399.489 221.675 405.129 219.927 407.396 221.105",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.693 224.425C408.693 224.425 406.108 223.605 403.821 225.158C401.959 226.422 400.294 229.766 400.383 232.279",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.751 228.146C409.751 228.146 404.73 228.593 404.537 232.961",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.142 205.072C376.015 195.747 362.727 182.502 362.727 182.502",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.401 198.059C383.401 198.059 382.637 199.896 379.459 202.292C376.28 204.688 370.365 206.332 370.365 206.332",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.409 193.787C380.409 193.787 380.963 195.773 376.883 198.64C372.803 201.506 367.224 201.824 367.224 201.824",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.486 190.403C377.486 190.403 378.036 192.551 373.828 195.026C369.621 197.5 365.082 197.242 365.082 197.242",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.593 187.675C374.593 187.675 375.184 189.045 371.077 191.505C366.97 193.964 363.745 193.281 363.745 193.281",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12 185.22C371.12 185.22 371.685 187.138 368.797 188.93C365.909 190.723 362.728 189.662 362.728 189.662",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.301 183.765C368.301 183.765 368.503 185.237 366.381 186.301C364.259 187.364 362.439 187.198 362.439 187.198",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.594 182.975C417.594 182.975 392.775 183.765 389.583 195.41",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.41 180.837C410.41 180.837 415.177 183.284 415.479 186.679",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.209 180.298C403.209 180.298 411.365 182.267 412.945 189.974",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.609 181.272C396.609 181.272 406.506 181.938 409.321 194.869",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.489 183.759C390.489 183.759 401.133 185.292 403.209 199.721",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.493 188.302C386.493 188.302 392.667 188.967 395.424 201.024",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M382.409 260.192C382.409 260.192 384.006 226.753 374.622 216.232",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M374.623 214.83C374.623 214.83 373.526 206.564 362.728 207.205C351.929 207.847 344.144 227.379 344.144 227.379C344.144 227.379 349.696 232.093 363.745 226.786C377.795 221.48 374.623 214.83 374.623 214.83Z",
    fill: "#9ABB50"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.878 215.817C374.878 215.817 356.477 213.202 344.144 227.381",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.658 207.406C366.658 207.406 372.004 211.627 370.89 223.056",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.925 207.891C359.925 207.891 365.754 212.237 364.249 226.652",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.267 212.285C354.267 212.285 357.535 219.595 358.251 228.319",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.667 215.701C350.667 215.701 350.715 223.576 353.845 229.056",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.507 222.396C346.507 222.396 346.185 226.993 348.579 229.057",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M378.504 259.926C378.504 259.926 377.937 252.252 375.358 250.604",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M374.979 250.004C374.979 250.004 380.084 254.415 372.992 260.21C365.901 266.005 362.249 263.579 362.249 263.579C362.249 263.579 360.987 254.326 368.193 251.267C374.013 248.797 374.979 250.004 374.979 250.004Z",
    fill: "#9ABB50"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.978 250.004C374.978 250.004 365.651 256.645 362.249 263.58",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.411 255.865C376.411 255.865 373.166 250.508 366.665 252.088",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.102 259.046C374.102 259.046 370.979 253.296 363.898 254.991",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.965 262.339C369.965 262.339 367.431 256.009 362.48 258.762",
    stroke: "#703333",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  }))), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M127.031 72.6856C127.031 72.6816 127.031 72.6779 127.031 72.674C127.031 72.669 127.032 72.6642 127.032 72.6593L126.429 67.2021H135.079L134.477 72.6586C134.477 72.6637 134.478 72.6688 134.478 72.6738C134.478 72.6777 134.477 72.6816 134.477 72.6857L134.478 72.7825H134.471C134.362 73.7879 132.74 74.5858 130.754 74.5858C128.769 74.5858 127.147 73.7879 127.037 72.7824H127.031L127.031 72.6856Z",
    fill: "url(#paint124_linear_3956_9012)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M125.758 70.3749C125.758 70.3802 125.76 70.3837 125.76 70.3892L125.758 70.5196H125.767C125.915 71.8683 128.091 72.94 130.754 72.94C133.417 72.94 135.593 71.8683 135.741 70.5196H135.75L135.748 70.3911C135.748 70.3858 135.75 70.3803 135.75 70.375C135.75 70.3679 135.748 70.3607 135.748 70.3537L136.454 64.7323C135.457 65.8363 133.28 66.6027 130.754 66.6025C128.226 66.6025 126.047 65.8362 125.052 64.7305L125.76 70.3554C125.76 70.3605 125.758 70.3677 125.758 70.3749Z",
    fill: "url(#paint125_linear_3956_9012)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M130.754 68.4738C128.378 68.4738 126.319 67.7671 125.295 66.7329L125.168 65.7061C126.143 66.8118 128.278 67.5781 130.754 67.5781C133.229 67.5781 135.362 66.8118 136.339 65.7079L136.213 66.7339C135.187 67.7669 133.13 68.4738 130.754 68.4738Z",
    fill: "url(#paint126_linear_3956_9012)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M130.754 70.2188C128.474 70.2241 126.497 69.5219 125.514 68.49L125.393 67.4635C126.329 68.567 128.378 69.3287 130.754 69.323C133.129 69.3176 135.177 68.5465 136.114 67.4404L135.993 68.4668C135.009 69.5019 133.034 70.2135 130.754 70.2188Z",
    fill: "url(#paint127_linear_3956_9012)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M130.754 71.964C128.562 71.964 126.663 71.2573 125.719 70.2231L125.602 69.1963C126.501 70.302 128.47 71.0683 130.754 71.0683C133.037 71.0683 135.004 70.302 135.905 69.1982L135.788 70.2241C134.843 71.2571 132.945 71.964 130.754 71.964Z",
    fill: "url(#paint128_linear_3956_9012)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M118.812 51.0335C118.812 54.906 120.655 58.3464 123.512 60.5293C124.124 60.9955 124.472 61.7314 124.472 62.5013V63.3766C124.472 63.8588 124.68 64.3179 125.053 64.7305C126.048 65.8362 128.227 66.6025 130.755 66.6025C133.28 66.6025 135.458 65.8362 136.455 64.7324C136.83 64.3197 137.037 63.8607 137.037 63.3766V62.5013C137.037 61.7243 137.394 60.9902 138.01 60.5185C140.961 58.259 142.828 54.6542 142.69 50.619C142.476 44.2956 137.264 39.1869 130.937 39.0922C124.258 38.9922 118.812 44.3778 118.812 51.0335Z",
    fill: "url(#paint129_linear_3956_9012)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M130.754 66.6019C134.223 66.6019 137.036 65.1577 137.036 63.3762C137.036 61.5946 134.223 60.1504 130.754 60.1504C127.285 60.1504 124.473 61.5946 124.473 63.3762C124.473 65.1577 127.285 66.6019 130.754 66.6019Z",
    fill: "#E5790E"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M131.915 63.2417C131.915 63.5468 132.394 63.794 132.986 63.794C133.577 63.794 134.057 63.5468 134.057 63.2417C134.057 62.9366 133.577 62.6895 132.986 62.6895C132.394 62.6895 131.915 62.9366 131.915 63.2417Z",
    fill: "#B25D10"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M127.514 63.2417C127.514 63.5468 127.994 63.794 128.585 63.794C129.177 63.794 129.656 63.5468 129.656 63.2417C129.656 62.9366 129.177 62.6895 128.585 62.6895C127.994 62.6896 127.514 62.9368 127.514 63.2417Z",
    fill: "#B25D10"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M132.956 63.2427C132.956 63.2427 132.271 48.3524 133.419 48.3128C134.567 48.2732 138.309 52.429 134.567 53.5372C130.826 54.6455 126.319 54.3684 125.553 52.3894C124.788 50.4105 126.021 48.6293 127.339 48.6293C128.657 48.6293 128.486 63.2425 128.486 63.2425",
    stroke: "white",
    strokeWidth: 0.512134,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M130.754 66.3548C134.142 66.3548 136.903 64.9769 137.03 63.2529C137.033 63.2941 137.036 63.3352 137.036 63.3769C137.036 65.1584 134.223 66.6026 130.754 66.6025C127.285 66.6025 124.473 65.1582 124.473 63.3767C124.473 63.3352 124.476 63.2941 124.479 63.2529C124.605 64.9769 127.366 66.3548 130.754 66.3548Z",
    fill: "url(#paint130_linear_3956_9012)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M119.78 40.4239L113.292 35.3379",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M116.03 50.9463H106.887",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M119.284 61.207L113.291 66.6007",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M141.266 40.4247L147.755 35.3389",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M145.016 50.9473H154.159",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M141.761 61.207L147.754 66.6007",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M130.291 35.3389V28.2363",
    stroke: "#FB8E12",
    strokeWidth: 0.341423,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3956_9012",
    x1: 208.21,
    y1: 392.865,
    x2: 255.159,
    y2: 101.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#0C5C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3956_9012",
    x1: 408.201,
    y1: 260.658,
    x2: 166.678,
    y2: 264.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8149,
    stopColor: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3956_9012",
    x1: 208.21,
    y1: 371.293,
    x2: 255.159,
    y2: 79.8428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3956_9012",
    x1: 238.442,
    y1: 158.575,
    x2: 239.791,
    y2: 174.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3956_9012",
    x1: 305.18,
    y1: 190.726,
    x2: 306.528,
    y2: 206.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3956_9012",
    x1: 304.743,
    y1: 158.429,
    x2: 249.959,
    y2: 77.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3956_9012",
    x1: 215.94,
    y1: 123.009,
    x2: 334.425,
    y2: 123.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3956_9012",
    x1: 100.96,
    y1: 151.62,
    x2: 142.307,
    y2: 151.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ABB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3956_9012",
    x1: 133.1,
    y1: 132.222,
    x2: 120.309,
    y2: 187.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3956_9012",
    x1: 158.013,
    y1: 7.8367,
    x2: 119.747,
    y2: 173.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ABB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3956_9012",
    x1: 148.635,
    y1: 240.832,
    x2: 193.894,
    y2: 240.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3956_9012",
    x1: 317.322,
    y1: 299.295,
    x2: 279.619,
    y2: 302.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3956_9012",
    x1: 272.189,
    y1: 300.429,
    x2: 306.09,
    y2: 300.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3956_9012",
    x1: 287.577,
    y1: 290.001,
    x2: 293.554,
    y2: 290.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3956_9012",
    x1: 285.605,
    y1: 278.202,
    x2: 295.417,
    y2: 278.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3956_9012",
    x1: 252.387,
    y1: 262.191,
    x2: 297.647,
    y2: 262.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3956_9012",
    x1: 261.38,
    y1: 227.907,
    x2: 190.996,
    y2: 185.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3956_9012",
    x1: 140.808,
    y1: 132.454,
    x2: 249.942,
    y2: 231.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2EFEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9F9F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3956_9012",
    x1: 184.266,
    y1: 159.654,
    x2: 184.415,
    y2: 159.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3956_9012",
    x1: 206.129,
    y1: 46.1672,
    x2: 161.708,
    y2: 46.1672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#608EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#608EE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3956_9012",
    x1: 161.708,
    y1: 90.5383,
    x2: 206.129,
    y2: 90.5383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ABB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9ABB50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3956_9012",
    x1: 266.774,
    y1: 206.439,
    x2: 210.791,
    y2: 206.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4678E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3956_9012",
    x1: 221.919,
    y1: 199.992,
    x2: 230.005,
    y2: 169.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EADA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3956_9012",
    x1: 209.376,
    y1: 184.554,
    x2: 245.743,
    y2: 184.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3956_9012",
    x1: 219.554,
    y1: 175.279,
    x2: 232.492,
    y2: 175.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3956_9012",
    x1: 210.929,
    y1: 204.903,
    x2: 266.649,
    y2: 204.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3956_9012",
    x1: 243.828,
    y1: 194.473,
    x2: 246.961,
    y2: 194.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3956_9012",
    x1: 241.57,
    y1: 195.56,
    x2: 244.703,
    y2: 195.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3956_9012",
    x1: 239.312,
    y1: 196.647,
    x2: 242.445,
    y2: 196.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3956_9012",
    x1: 237.054,
    y1: 197.732,
    x2: 240.187,
    y2: 197.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3956_9012",
    x1: 234.796,
    y1: 198.819,
    x2: 237.929,
    y2: 198.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3956_9012",
    x1: 232.538,
    y1: 199.906,
    x2: 235.671,
    y2: 199.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3956_9012",
    x1: 230.28,
    y1: 200.992,
    x2: 233.413,
    y2: 200.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3956_9012",
    x1: 228.022,
    y1: 202.079,
    x2: 231.156,
    y2: 202.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3956_9012",
    x1: 225.764,
    y1: 203.165,
    x2: 228.897,
    y2: 203.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3956_9012",
    x1: 223.506,
    y1: 204.252,
    x2: 226.639,
    y2: 204.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3956_9012",
    x1: 221.248,
    y1: 205.337,
    x2: 224.381,
    y2: 205.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3956_9012",
    x1: 218.99,
    y1: 206.424,
    x2: 222.123,
    y2: 206.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3956_9012",
    x1: 216.732,
    y1: 207.511,
    x2: 219.865,
    y2: 207.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3956_9012",
    x1: 245.591,
    y1: 195.408,
    x2: 248.724,
    y2: 195.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3956_9012",
    x1: 243.333,
    y1: 196.494,
    x2: 246.466,
    y2: 196.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3956_9012",
    x1: 241.075,
    y1: 197.58,
    x2: 244.208,
    y2: 197.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3956_9012",
    x1: 238.817,
    y1: 198.666,
    x2: 241.95,
    y2: 198.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3956_9012",
    x1: 236.559,
    y1: 199.753,
    x2: 239.692,
    y2: 199.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3956_9012",
    x1: 234.301,
    y1: 200.839,
    x2: 237.434,
    y2: 200.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3956_9012",
    x1: 232.042,
    y1: 201.926,
    x2: 235.176,
    y2: 201.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3956_9012",
    x1: 229.785,
    y1: 203.013,
    x2: 232.918,
    y2: 203.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3956_9012",
    x1: 227.527,
    y1: 204.1,
    x2: 230.66,
    y2: 204.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3956_9012",
    x1: 225.269,
    y1: 205.185,
    x2: 228.402,
    y2: 205.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3956_9012",
    x1: 223.011,
    y1: 206.272,
    x2: 226.144,
    y2: 206.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3956_9012",
    x1: 220.753,
    y1: 207.359,
    x2: 223.886,
    y2: 207.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3956_9012",
    x1: 218.495,
    y1: 208.445,
    x2: 221.628,
    y2: 208.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3956_9012",
    x1: 247.353,
    y1: 196.341,
    x2: 250.487,
    y2: 196.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3956_9012",
    x1: 245.096,
    y1: 197.428,
    x2: 248.229,
    y2: 197.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3956_9012",
    x1: 242.838,
    y1: 198.514,
    x2: 245.971,
    y2: 198.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3956_9012",
    x1: 240.58,
    y1: 199.601,
    x2: 243.713,
    y2: 199.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3956_9012",
    x1: 238.322,
    y1: 200.688,
    x2: 241.455,
    y2: 200.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3956_9012",
    x1: 236.064,
    y1: 201.774,
    x2: 239.197,
    y2: 201.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3956_9012",
    x1: 233.806,
    y1: 202.86,
    x2: 236.939,
    y2: 202.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3956_9012",
    x1: 231.548,
    y1: 203.947,
    x2: 234.681,
    y2: 203.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3956_9012",
    x1: 229.29,
    y1: 205.034,
    x2: 232.423,
    y2: 205.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3956_9012",
    x1: 227.032,
    y1: 206.119,
    x2: 230.165,
    y2: 206.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3956_9012",
    x1: 224.773,
    y1: 207.206,
    x2: 227.906,
    y2: 207.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3956_9012",
    x1: 222.516,
    y1: 208.292,
    x2: 225.649,
    y2: 208.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3956_9012",
    x1: 220.258,
    y1: 209.379,
    x2: 223.391,
    y2: 209.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3956_9012",
    x1: 249.117,
    y1: 197.274,
    x2: 252.25,
    y2: 197.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3956_9012",
    x1: 246.859,
    y1: 198.361,
    x2: 249.993,
    y2: 198.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3956_9012",
    x1: 244.601,
    y1: 199.447,
    x2: 247.734,
    y2: 199.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3956_9012",
    x1: 242.343,
    y1: 200.533,
    x2: 245.476,
    y2: 200.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3956_9012",
    x1: 240.085,
    y1: 201.619,
    x2: 243.218,
    y2: 201.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3956_9012",
    x1: 237.827,
    y1: 202.706,
    x2: 240.96,
    y2: 202.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3956_9012",
    x1: 235.569,
    y1: 203.792,
    x2: 238.702,
    y2: 203.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3956_9012",
    x1: 233.311,
    y1: 204.879,
    x2: 236.445,
    y2: 204.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3956_9012",
    x1: 231.053,
    y1: 205.966,
    x2: 234.186,
    y2: 205.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3956_9012",
    x1: 228.795,
    y1: 207.051,
    x2: 231.928,
    y2: 207.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3956_9012",
    x1: 226.537,
    y1: 208.139,
    x2: 229.67,
    y2: 208.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3956_9012",
    x1: 224.279,
    y1: 209.225,
    x2: 227.412,
    y2: 209.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3956_9012",
    x1: 222.021,
    y1: 210.312,
    x2: 225.154,
    y2: 210.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3956_9012",
    x1: 250.879,
    y1: 198.209,
    x2: 254.012,
    y2: 198.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3956_9012",
    x1: 248.622,
    y1: 199.296,
    x2: 251.755,
    y2: 199.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3956_9012",
    x1: 246.363,
    y1: 200.381,
    x2: 249.496,
    y2: 200.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3956_9012",
    x1: 244.106,
    y1: 201.468,
    x2: 247.239,
    y2: 201.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3956_9012",
    x1: 241.848,
    y1: 202.555,
    x2: 244.981,
    y2: 202.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3956_9012",
    x1: 239.59,
    y1: 203.642,
    x2: 242.723,
    y2: 203.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3956_9012",
    x1: 237.332,
    y1: 204.728,
    x2: 240.465,
    y2: 204.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3956_9012",
    x1: 235.074,
    y1: 205.815,
    x2: 238.207,
    y2: 205.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3956_9012",
    x1: 232.815,
    y1: 206.902,
    x2: 235.949,
    y2: 206.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3956_9012",
    x1: 230.557,
    y1: 207.987,
    x2: 233.69,
    y2: 207.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3956_9012",
    x1: 228.299,
    y1: 209.074,
    x2: 231.432,
    y2: 209.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3956_9012",
    x1: 226.041,
    y1: 210.161,
    x2: 229.175,
    y2: 210.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_3956_9012",
    x1: 223.783,
    y1: 211.247,
    x2: 226.916,
    y2: 211.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3956_9012",
    x1: 252.642,
    y1: 199.142,
    x2: 255.775,
    y2: 199.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3956_9012",
    x1: 250.384,
    y1: 200.229,
    x2: 253.517,
    y2: 200.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_3956_9012",
    x1: 248.126,
    y1: 201.315,
    x2: 251.259,
    y2: 201.315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3956_9012",
    x1: 245.868,
    y1: 202.401,
    x2: 249.001,
    y2: 202.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3956_9012",
    x1: 243.61,
    y1: 203.488,
    x2: 246.743,
    y2: 203.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3956_9012",
    x1: 241.352,
    y1: 204.575,
    x2: 244.485,
    y2: 204.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_3956_9012",
    x1: 239.094,
    y1: 205.661,
    x2: 242.227,
    y2: 205.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3956_9012",
    x1: 236.836,
    y1: 206.747,
    x2: 239.97,
    y2: 206.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3956_9012",
    x1: 234.578,
    y1: 207.834,
    x2: 237.711,
    y2: 207.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_3956_9012",
    x1: 232.32,
    y1: 208.919,
    x2: 235.453,
    y2: 208.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3956_9012",
    x1: 230.062,
    y1: 210.006,
    x2: 233.195,
    y2: 210.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3956_9012",
    x1: 227.804,
    y1: 211.093,
    x2: 230.937,
    y2: 211.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_3956_9012",
    x1: 225.546,
    y1: 212.18,
    x2: 228.679,
    y2: 212.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_3956_9012",
    x1: 155.719,
    y1: 220.648,
    x2: 308.48,
    y2: 199.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3060AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4678E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_3956_9012",
    x1: 244.764,
    y1: 209.223,
    x2: 226.477,
    y2: 204.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF8F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_3956_9012",
    x1: 301.598,
    y1: 123.691,
    x2: 284.326,
    y2: 173.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_3956_9012",
    x1: 232.369,
    y1: 191.618,
    x2: 227.334,
    y2: 213.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_3956_9012",
    x1: 318.005,
    y1: 95.9648,
    x2: 309.321,
    y2: 133.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_3956_9012",
    x1: 128.961,
    y1: 277.936,
    x2: 166.663,
    y2: 281.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_3956_9012",
    x1: 174.094,
    y1: 279.07,
    x2: 140.192,
    y2: 279.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_3956_9012",
    x1: 158.706,
    y1: 268.642,
    x2: 152.728,
    y2: 268.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_3956_9012",
    x1: 160.678,
    y1: 256.843,
    x2: 150.866,
    y2: 256.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_3956_9012",
    x1: 167.058,
    y1: 148.651,
    x2: 180.813,
    y2: 163.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_3956_9012",
    x1: 164.07,
    y1: 192.556,
    x2: 137.379,
    y2: 204.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_3956_9012",
    x1: 178.677,
    y1: 166.849,
    x2: 185.757,
    y2: 165.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_3956_9012",
    x1: 136.374,
    y1: 102.888,
    x2: 152.05,
    y2: 102.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_3956_9012",
    x1: 156.887,
    y1: 129.802,
    x2: 142.12,
    y2: 129.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_3956_9012",
    x1: 199.976,
    y1: 158.365,
    x2: 184.709,
    y2: 158.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB4B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_3956_9012",
    x1: 384.581,
    y1: 117.991,
    x2: 374.018,
    y2: 182.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F4F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_3956_9012",
    x1: 346.096,
    y1: 125.696,
    x2: 412.012,
    y2: 125.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D8D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_3956_9012",
    x1: 382.148,
    y1: 280.192,
    x2: 419.311,
    y2: 306.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C5C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5C93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_3956_9012",
    x1: 371.823,
    y1: 254.634,
    x2: 395.268,
    y2: 254.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_3956_9012",
    x1: 398.431,
    y1: 269.598,
    x2: 373.064,
    y2: 272.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DA9B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_3956_9012",
    x1: 135.079,
    y1: 70.8942,
    x2: 126.429,
    y2: 70.8942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0361,
    stopColor: "#6BCDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_3956_9012",
    x1: 136.454,
    y1: 68.8351,
    x2: 125.052,
    y2: 68.8351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86E2D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_3956_9012",
    x1: 136.339,
    y1: 67.0899,
    x2: 125.168,
    y2: 67.0899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52897A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_3956_9012",
    x1: 136.114,
    y1: 68.8223,
    x2: 125.393,
    y2: 68.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52897A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3956_9012",
    x1: 135.905,
    y1: 70.5802,
    x2: 125.602,
    y2: 70.5802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52897A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309E98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3956_9012",
    x1: 142.697,
    y1: 52.8467,
    x2: 118.812,
    y2: 52.8467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9952,
    stopColor: "#FA8A13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_3956_9012",
    x1: 137.036,
    y1: 64.9277,
    x2: 124.472,
    y2: 64.9277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CDAC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResoucesbanner);
export default __webpack_public_path__ + "static/media/resoucesbanner.fb9809ddad9545dcca72961aee576def.svg";
export { ForwardRef as ReactComponent };